module.exports = {
  lang: '简体中文',
  // router, 路由
  router: {
    title: '极飞物联-连接土地、作物与人',
    home: {
      title: '极飞物联-连接土地、作物与人',
      name: 'XIOT',
      desc: ''
    },
    case: {
      title: '极飞物联-解决方案',
      name: '解决方案',
      desc: ''
    },
    paddy: {
      title: '极飞物联-水稻灌溉解决方案',
      name: '水稻灌溉解决方案',
      desc: '实现水稻合理灌溉'
    },
    cotton: {
      title: '极飞物联-棉田灌溉解决方案',
      name: '棉田灌溉解决方案',
      desc: '智能灌溉棉田'
    },
    trace: {
      title: '极飞物联-产品溯源解决方案',
      name: '产品溯源解决方案',
      desc: '为农产品提供产品溯源'
    },
    products: {
      title: '极飞物联-产品',
      name: '产品',
      desc: ''
    },
    sensor: {
      name: '传感器设备',
      desc: ''
    },
    IHUB1S: {
      title: '极飞物联-IHUB1S 物联盒子',
      name: 'IHUB1S 物联盒子',
      desc: '实现设备间的智能联动'
    },
    IFC16S: {
      title: '极飞物联-IFC13S 农业智能相机',
      name: 'IFC13S 农业智能相机',
      desc: '1300像素，远程农事监测'
    },
    ISM50: {
      title: '极飞物联-ISM50S 土壤监测仪',
      name: 'ISM50S 土壤监测仪',
      desc: '多层深度土壤监测'
    },
    IWS7: {
      title: '极飞物联-IWS7S 农业气象站',
      name: 'IWS7S 农业气象站',
      desc: '一站式测量气象七要素'
    },
    IWS3: {
      title: '极飞物联-IWS3S 农业气象站',
      name: 'IWS3S 农业气象站',
      desc: '精准气象三要素测量'
    },
    IFC16: {
      title: '极飞物联-IFC16 农业智能相机',
      name: 'IFC16 农业智能相机',
      desc: '1600像素，远程农事监测'
    },
    all: {
      title: '极飞物联-所有产品',
      name: '更多',
      desc: '...'
    },
    parts: {
      name: '配件',
      desc: ''
    },
    solar: {
      title: '极飞物联-太阳能充电板',
      name: '太阳能充电板',
      desc: '简单的供电方式'
    },
    fixedbanister: {
      title: '极飞物联-固定立杆',
      name: '固定立杆',
      desc: '支持简易的安装'
    },
    wire: {
      title: '极飞物联-一分二电源线',
      name: '一分二电源线',
      desc: '拓展更多设备'
    },
    api: {
      title: '极飞物联-开放',
      name: '开放',
      desc: ''
    },
    service: {
      title: '极飞物联-服务',
      name: '服务',
      desc: ''
    },
    guide: {
      title: '极飞物联-产品指南',
      name: '产品指南',
      desc: '更好使用产品'
    },
    afterMarket: {
      title: '极飞物联-售后服务',
      name: '售后服务',
      desc: '售后政策、设备保修'
    },
    download: {
      title: '极飞物联-文档下载',
      name: '文档下载',
      desc: '产品简介、使用说明和规格参数等'
    },
    question: {
      title: '极飞物联-问题解答',
      name: '问题解答',
      desc: '常见问题汇总'
    },
    community: {
      title: '极飞物联-社区',
      name: '社区',
      desc: ''
    },
    IFC16SInstall: {
      title: '极飞物联-IFC16S 农业智能相机安装'
    },
    ISM50Install: {
      title: '极飞物联-ISM50 土壤监测仪安装'
    },
    IWS7Install: {
      title: '极飞物联-IWS7 农业气象站安装'
    },
    IWS3Install: {
      title: '极飞物联-IWS3 农业气象站安装'
    },
    FM1Install: {
      title: '极飞物联-FM1安装'
    },
    FM2Install: {
      title: '极飞物联-FM2安装'
    },
    IFC16Install: {
      title: '极飞物联- IFC16 农业智能相机安装'
    },
    solarInstall: {
      title: '极飞物联-太阳能充电板安装'
    },
    FixedPoleInstall: {
      title: '极飞物联-户外固定立杆安装'
    },
    user: {
      title: '极飞物联-个人中心'
    },
    platform: {
      title: '极飞物联-开放平台'
    },
    userhome: {
      title: '极飞物联-我的主页'
    },
    help: {
      title: '极飞物联-帮助',
      name: '帮助',
      desc: ''
    }
  },
  users: {
    signin: '登录',
    signup: '注册',
    user: ' 个人中心',
    platform: ' 开放平台',
    data: ' 数据管理',
    homepage: ' 我的主页',
    logout: ' 退出登录'
  },
  // 首页
  index: {
    banner: {
      xiot: 'XIOT 物联平台',
      desc: '连接土地、作物、农民与消费者'
    },
    intro: {
      title: '农业物联网平台',
      desc: '提供多种农业解决方案、多种气象硬件产品、多终端软件产品、开放平台，支持多样化设备接入。对农产品种植、管理提供数据采集，可视化、自动化管理，满足企业、农户对构建智慧农业整体解决方案，提高种植效率，降低成本'
    },
    possibilities: {
      title: '提供更多可能',
      tab1: {
        title: '完善的解决方案',
        desc: '提供农业灌溉、种植解决方案，改善传统种植'
      },
      tab2: {
        title: '多品类、可扩展智能硬件',
        desc: '自研发多种气象设备，可扩展硬件生态，提供更多设备支持'
      },
      tab3: {
        title: '安全、可靠的开放平台',
        desc: '提供实现可接入的智能硬件平台、api文档'
      },
      tab4: {
        title: '多终端软件',
        desc: '提供App、小程序、网站多端远程管理、监控'
      },
      tab5: {
        title: '增值服务',
        desc: '自带SIM卡，支持数据服务购买'
      }
    },
    framework: {
      title: '产品架构图'
    },
    contact: {
      title: '联系我们',
      tab1: {
        title: '400-980-3131',
        desc: '咨询热线'
      },
      tab2: {
        title: '',
        desc: '扫码关注“极飞物联”'
      }
    }
  },
  // 水稻案例
  paddy: {
    title: '水稻灌溉解决方案',
    intro: {
      title: '方案简介',
      desc: '水稻灌溉场景方案，利用农业物联网技术，采用智能盒子联动智能闸阀、智能电机、运用软件远程智能控制实现灌溉流程中泵房、田格、斗渠节点控制，达到合理灌溉目的，同时简易布局方案，具有广泛的适用性，随装随用，安全可靠，最大程度减少人工干预，逐步实现少人化，无人化管理。'
    },
    flow: {
      title: '核心流程',
      tab1: {
        title: '泵房管理',
        desc: '电机控制闸门开关液位器监测水位情况'
      },
      tab2: {
        title: '田格管理',
        desc: '自动闸阀控制田间水渠进水排水管道'
      },
      tab3: {
        title: '斗渠管理',
        desc: '电机控制闸门开关'
      }
    },
    hardware: {
      title: '硬件生态',
      tab1: '智能盒子',
      tab2: '电动闸阀',
      tab3: '液位计',
      tab4: '电机'
    },
    painPoint: {
      title: '解决痛点',
      tab1: {
        title: '广泛适用性',
        desc: '提供传感器技术、通讯技术、计算机技术于一体的灌溉管理系统适用性更广'
      },
      tab2: {
        title: '降低成本、提高效率',
        desc: '使用自动采集水位计、气象传感器、智能灌溉排水、无需人工参与、降低成本'
      },
      tab3: {
        title: '多种模式管理',
        desc: '支持定时灌溉、周期灌溉、手动灌溉等多种模式、随时启停'
      },
      tab4: {
        title: '实时异常提醒',
        desc: '支持后台异常提醒功能，减少人工勘查水稻田异常'
      },
      tab5: {
        title: '数据记录、可追溯',
        desc: '支持记录实时数据、统计数据、便于后续调研或数据查看'
      }
    }
  },
  // 棉田案例
  cotton: {
    title: '棉田灌溉解决方案',
    intro: {
      title: '方案简介',
      desc: '棉田灌溉场景方案，利用农业物联网技术，采用智能盒子联动智能电机、液位计、控制器等，运用软件远程智能控制棉田灌溉蓄水、泵房、施肥、滴灌节点，达到滴灌目的，同时简易布局方案，具有广泛的适用性，随装随用，安全可靠，最大程度减少人工干预，逐步实现少人化，无人化管理。'
    },
    flow: {
      title: '核心流程',
      tab1: {
        title: '蓄水池管理',
        desc: '自动控制水渠闸门，保持蓄水池水位'
      },
      tab2: {
        title: '泵房管理',
        desc: '根据轮灌周期自动控制泵房水泵工作'
      },
      tab3: {
        title: '施肥管理',
        desc: '精准控制施肥机，氮、磷、钾肥施放'
      },
      tab4: {
        title: '滴灌管理',
        desc: '控制滴灌带出水桩阀门'
      }
    },
    hardware: {
      title: '硬件生态',
      tab1: '智能盒子',
      tab2: '电动闸阀',
      tab3: '液位计',
      tab4: '电机'
    },
    painPoint: {
      title: '解决痛点',
      tab1: {
        title: '广泛适用性',
        desc: '提供传感器技术、通讯技术、计算机技术于一体的灌溉管理系统适用性更广'
      },
      tab2: {
        title: '降低成本、提高效率',
        desc: '使用自动采集水位计、气象传感器、智能灌溉排水、无需人工参与、降低成本'
      },
      tab3: {
        title: '多种模式管理',
        desc: '支持定时灌溉、周期灌溉、手动灌溉等多种模式、随时启停'
      },
      tab4: {
        title: '实时异常提醒',
        desc: '支持后台异常提醒功能，减少人工勘查水稻田异常'
      },
      tab5: {
        title: '数据记录、可追溯',
        desc: '支持记录实时数据、统计数据、便于后续调研或数据查看'
      }
    }
  },
  // 产品溯源
  trace: {
    title: '产品溯源解决方案',
    intro: {
      title: '方案简介',
      desc: '产品溯源解决场景方案，利用各种气象设备，摄像头设备记录农产品种植过程，自主编辑生成追溯码，为农产品提供食品溯源、农业信息展示，提升农产品的价值，增加销量。'
    },
    flow: {
      title: '追溯流程',
      tab1: {
        title: '种植环节',
        desc: '记录产品种植各阶段'
      },
      tab2: {
        title: '加工环节',
        desc: '监测产品进入加工环节'
      },
      tab3: {
        title: '仓储环节',
        desc: '产品放置仓储等待输送各地销售'
      },
      tab4: {
        title: '销售环节',
        desc: '消费者扫码追溯产品来源'
      }
    },
    painPoint: {
      title: '解决痛点',
      tab1: {
        title: '自定义扫码页',
        desc: '提供可定义扫码页面，可定义产品信息及定义产品生命周期信息管理，实现各环节可追溯'
      },
      tab2: {
        title: '全生命周期管理',
        desc: '通过物联农业摄像头，可自动采集产品种植、加工、仓储、销售等各环节数据，提供实时高清数据'
      },
      tab3: {
        title: '打造品牌，增加优势',
        desc: '绿色透明化追溯产品生命周期，建立溯源档案，有利于打造产品的安全性、可信任度、凸显优势，提升产品品牌'
      },
      tab4: {
        title: '提升产品销量',
        desc: '提供产品质量溯源，增强消费者信任，拓宽用户来源，拉动消费者购买力'
      }
    }
  },
  // 所有产品页
  all: {
    title: '全部产品',
    prods: {
      title: '产品',
      ihub: {
        pre_title: '极飞 IHUB1S', // 名称前缀
        title: '物联盒子',
        desc: '实现设备间的智能联动'
      },
      fc2: {
        pre_title: '极飞 IFC13S', // 名称前缀
        title: '极飞 IFC13S 农业智能相机',
        desc: '记录每一寸土地'
      },
      sm: {
        title: '极飞 ISM50S 土壤监测仪',
        desc: '快速了解土地，修复与土壤的关系'
      },
      ht: {
        title: '极飞 IWS3S 农业气象站',
        desc: '精准感知农田温湿'
      },
      ws: {
        title: '极飞 IWS7S 农业气象站',
        desc: '抓住小气候，精准把握农田脉搏'
      },
      fc1: {
        title: '极飞 IFC16 农业智能相机',
        desc: '高清影像，记录作物生长完整过程'
      }
    },
    parts: {
      title: '配件',
      solar: {
        title: '太阳能板',
        desc: '提供户外简单便捷的供电方式'
      },
      banister: {
        title: '固定立杆',
        desc: '安装简易、快速部署'
      }
    }
  },
  // 产品
  prods: {
    fm1: {
      title: 'FM1 智能监测站',
      desc: '用上微信小程序的智能监测站，实现高清图像及气象数据的实时采集和远程监控',
      tab1: {
        tips: '双摄像头，超大视界',
        desc: '可自动拼接生成160°高清大画幅图像，空旷地区监测范围超过50亩'
      },
      tab2: {
        tips: '精准监测，实时采集',
        desc: '采用高集成度传感器，实时采集环境温度、湿度、大气压和光照强度',
        details: {
          temp: '温度',
          humidity: '湿度',
          air: '气压',
          light: '光强'
        }
      },
      tab3: {
        tips: '数据实时同步',
        desc: '数据和图像每15分钟更新一次，通过4G网络实时同步至云端'
      },
      tab4: {
        tips: '微信小程序，远程监控',
        desc: '用户可通过微信小程序“极飞稻草人”，随时查看实时气象数据，FM1拍摄的广角图和「全天时景」小视频'
      },
      tab5: {
        tips: '太阳能供电，安装简单',
        desc: '无需拉设电线，配合内置高容量、低功耗电池，阴雨天仍可持续工作7天'
      },
      tab6: {
        tips: 'GPS精准定位',
        desc: '用户可通过地图直观了解FM1的准确安装位置，便于同时管理多个设备'
      },
      details: {
        name: '规格参数',
        mbd: '主机尺寸规格',
        spd: '太阳能板尺寸规格',
        pd: '立杆尺寸规格',
        spp: '太阳能板功率',
        cam: '摄像头',
        bc: '电池容量',
        imr: '光照测量范围',
        tmr: '温度测量范围',
        hmr: '湿度测量范围',
        apmr: '气压测量范围'
      }
    },
    fm2: {
      title: 'FM2 智能监测站',
      desc: '极飞研发的全新智能气象监测解决方案，用户可通过微信小程序，实时查询监测地的气象情况',
      tab1: {
        tips: '精准监测，实时采集',
        desc: '集成多个先进传感器，实时采集降雨量、风速、风向等气象数据',
        details: {
          rain: '降雨量',
          wind: '风速',
          windd: '风向'
        }
      },
      tab2: {
        tips: '土壤监测扩展',
        desc: '可根据需要灵活选配，模块包含土壤温度和含水量数据监测'
      },
      tab3: {
        tips: '数据实时同步',
        desc: '数据和图像每15分钟更新一次，通过4G网络实时同步至云端'
      },
      tab4: {
        tips: '微信小程序，远程监控',
        desc: '用户可通过微信小程序“极飞稻草人”，随时查看实时气象数据，FM2采集的降雨量和土壤含水量等数据'
      },
      tab5: {
        tips: '太阳能供电，安装简单',
        desc: '无需拉设电线，配合内置高容量、低功耗电池，阴雨天仍可持续工作7天'
      },
      tab6: {
        tips: 'GPS精准定位',
        desc: '用户可通过地图直观了解FM2的准确安装位置，便于同时管理多个设备'
      },
      details: {
        name: '规格参数',
        mbd: '主机尺寸规格',
        spd: '太阳能板尺寸规格',
        pd: '立杆尺寸规格',
        spp: '太阳能板功率',
        bc: '电池容量',
        wsp: '风速精度',
        swcp: '土壤含水量精度',
        stp: '土壤温度精度',
        rr: '降雨量分辨率',
        wsmr: '风速测量范围',
        smcmr: '风向测量范围',
        swcmr: '土壤含水量测量范围',
        stmr: '土壤温度测量范围'
      }
    },
    fc1: {
      title1: '极飞',
      title2: '',
      title3: 'IFC16 农业智能相机',
      desc: 'IFC16 农业智能相机，是极飞农业物联系统中的一款高清影像采集设备，用于记录作物的生长过程，为后续作物生长分析和产品追溯提供数据支持',
      tab1: {
        tips: '高清影像',
        desc: '1300万像素高清影像，看清作物生长不同时期的每一个细节',
        details: {
          plant: '种植',
          bud: '萌芽',
          grow: '生长'
        }
      },
      tab5: {
        tips: '防水防尘',
        desc: '暴雨天气、高温沙漠等户外各种恶劣环境中，依然能够稳定工作'
      },
      tab2: {
        tips: '数据实时同步',
        desc: '图像每30分钟更新一次，通过4G网络实时同步至云端'
      },
      tab3: {
        tips: '超长待机时间',
        desc: '内置12000mAh高容量电池，在阴雨天气仍能持续工作14天',
        details: {
          battery: '高容量电池',
          day: '14天续航'
        }
      },
      tab4: {
        tips: 'GPS精准定位',
        desc: '用户可通过地图直观了解的设备准确安装位置，便于同时管理多个设备'
      },
      details: {
        name: '规格参数',
        ws: {
          title: '相机重量与尺寸',
          value1: '596g',
          value2: '67.2*67.2*148mm'
        },
        temp: {
          title: '工作温度',
          value: '-20~60度'
        },
        usb: {
          title: 'USB充电与电池容量',
          value1: '5V~2A',
          value2: '12000mAh'
        },
        focallength: {
          title: '镜头视场角',
          value: '对角95度'
        },
        lens: {
          title: '焦距与像素',
          value1: '3.8mm',
          value2: '16M'
        },
        sensor: {
          title: '传感器类型',
          value: '1/2.3CMOS'
        },
        image: {
          title: '最大图片分辨率',
          value: '4608*3456'
        },
        grid: {
          title: '网络制式',
          value1: '支持移动/联通/电信',
          value2: '4G/3G/2G'
        },
        protective: {
          title: '防护级别',
          value: '户外防水防尘（IP65）'
        }
      }
    },
    fc2: {
      title1: '极飞',
      title2: '',
      title3: 'IFC13S 农业智能相机',
      desc: '记录每一寸土地',
      tab_nav: {
        item1: '概述',
        item2: '参数'
      },
      tab1: {
        item1: {
          tips: '高清影像',
          desc: '1300 万像素'
        },
        item3: {
          tips: '视频直播',
          desc: '足不出户，农事监控'
        },
        item4: {
          tips: '防水防尘',
          desc: 'IP65 防护等级'
        },
        item5: {
          tips: '云端管理',
          desc: 'GPS 定位，多终端随时查看'
        },
        item6: {
          tips: '实时分享',
          desc: '4G 在线，同步分享'
        }
      },
      tab2: {
        tips: '安全追溯',
        desc: '为每一件商品生成二维码，追溯品牌信息、产品认证信息、实时照片，全程透明化展现，打造产品品牌'
      },
      tab3: {
        tips1: '间隔拍照、',
        tips2: '定格作物生长瞬间',
        desc: '可设置特定拍照时间点，抓取作物动态瞬间。更可自动生成延时摄影视频，全天时景，一目了然。',
        dates: {
          date1: '2019-07-12',
          date2: '2019-07-27',
          date3: '2019-08-15',
          date4: '2019-08-25',
          date5: '2019-09-20'
        }
      },
      tab5: {
        tips: '视频直播，零距离展示农田生态',
        desc: '随时切换有声直播，直观监控一切农事活动，如施肥、杀虫、采摘等，建立与消费者的信任关系。'
      },
      tab6: {
        tips: '防水防尘  室内室外都能用',
        desc: 'IP65 级防水防尘设计，无惧风吹日晒，适应室内室外各种环境。'
      },
      tab7: {
        tips: '多终端查看，足不出户远程管理',
        desc: '设备内置 GPS 定位系统，通过电脑或手机了解设备分布位置，随时随地掌握农田作物动态。'
      },
      tab8: {
        tips: '4G 网络传输，云端同步，实时分享',
        desc: '全网兼容，通过 4G 网络自动上传农田实景至云端，随时下载，实时分享。'
      },
      tab9: {
        tips: '太阳能供电，无需布线',
        desc: '太阳能电池板供电，无需额外拉线，部署更灵活；超长续航，连续阴雨15天也能维持设备正常运转。',
        details: {
          item1: {
            title: '输入',
            value: '5~16V'
          },
          item2: {
            title: '输出',
            value: '15V/2A'
          },
          item3: {
            title: '电池容量',
            value: '7500mAh/7.4V'
          },
          item4: {
            title: '功率',
            value: '15W'
          },
          item5: {
            title: '工作温度',
            value: '-20~60 ℃'
          },
          item6: {
            title: '防护等级',
            value: 'IP67'
          },
          item7: {
            title: '主体重量',
            value: '1370g'
          },
          item8: {
            title: '主体尺寸',
            value: 'L401×W256×H35.4mm'
          }
        }
      },
      tab10: {
        tips: 'IFC13S 农业智能相机应用案例',
        case1: {
          title: '蚂蚁森林',
          desc: '实时监测树苗生长情况，守护环境'
        },
        case2: {
          title: '葡萄酒庄园',
          desc: '守护每一颗葡萄的终极梦想'
        },
        case3: {
          title: '北大荒黑土地',
          desc: '记录时间如何成就石板大米的味道'
        },
        case4: {
          title: '平溪蜜柚',
          desc: '安全溯源不用担心甜蜜负担'
        },
        case5: {
          title: '海南东方农场火龙果基地',
          desc: '记录每一颗果实的成长历程'
        }
      },
      tab11: {
        title: '你可能还对以下产品感兴趣',
        item1: {
          title1: '极飞',
          title2: ' ',
          title3: 'IHUB1S 物联盒子'
        },
        item2: {
          title1: '极飞',
          title2: ' ',
          title3: 'ISM50S 土壤监测仪'
        },
        item3: {
          title1: '极飞',
          title2: ' ',
          title3: 'IWS7S 农业气象站'
        },
        item4: {
          title1: '极飞',
          title2: ' ',
          title3: 'IWS3S 农业气象站'
        }
      },
      tab12: {
        title: '产品外观',
        weight: '重量 220g'
      },
      details: {
        name: '产品参数',
        item1: {
          title: '工作电压',
          value: '5~15V'
        },
        item2: {
          title: '供电方式',
          value: '太阳能板供电/适配器供电 '
        },
        item3: {
          title: '工作温度 ',
          value: '-20~60℃ '
        },
        item4: {
          title: '防护等级',
          value: 'IP65'
        },
        item5: {
          title: '通讯方式',
          value: '4G/WiFi/蓝牙 '
        },
        item6: {
          title: '定位模式',
          value: 'GPS/基站定位 '
        },
        item7: {
          title: '支持运营商 ',
          value: '移动/联通/电信，内置电信贴片卡'
        },
        item8: {
          title: '分辨率 ',
          value: '1300万'
        },
        item9: {
          title: '焦距',
          value: '3.57mm '
        },
        item10: {
          title: '水平视角',
          value: '67.9° '
        },
        item11: {
          title: '垂直视角',
          value: '53.7° '
        },
        item12: {
          title: '对角视角',
          value: '80° '
        },
        item13: {
          title: '语音',
          value: '支持录音'
        },
        item14: {
          title: '视频帧率',
          value: '720p@25fps'
        },
        item15: {
          title: '夜视范围',
          value: '不支持 '
        }
      }
    },
    sm: {
      title1: '极飞',
      title2: '',
      title3: 'ISM50S 土壤监测仪',
      desc: '快速了解土地，修复与土壤的关系',
      tab_nav: {
        item1: '概述',
        item2: '参数'
      },
      tab1: {
        item1: {
          tips: '全面监测',
          desc: '土壤温度、含水量、电导率'
        },
        item2: {
          tips: '深度土壤监测',
          desc: '5 层感知，直达根部'
        },
        item3: {
          tips: '防沙防浸',
          desc: 'IP68 防护等级'
        },
        item4: {
          tips: 'App 异常提醒',
          desc: '达到阈值主动通知'
        },
        item5: {
          tips: '云端管理',
          desc: 'GPS 定位，多终端随时查看'
        },
        item6: {
          tips: '实时分享',
          desc: '4G 在线，同步分享'
        }
      },
      tab2: {
        tips: '五级土壤同时监测，IP68 防护等级无惧沙尘水浸',
        desc: '具有IP68防护等级的传感部位深埋至地下 50cm，无惧沙尘水浸，防锈耐腐蚀，免受干扰，精准测量 5 级不同层次的土壤温度、含水量及电导率，并适用于各种土质。'
      },
      tab3: {
        tips: 'App 实时监测，异常情况，一目了然',
        desc: '当土壤发生异常情况时将触发阈值提醒功能，App 管理平台将主动推送通知，提醒、指导用户及时处理。'
      },
      tab4: {
        tips: '足不出户，远程管理',
        desc: '内置 GPS 精准定位系统，通过手机 App 或电脑直观了解所有设备的安装位置，并随时随地查看土壤情况。'
      },
      tab5: {
        tips: '4G 网络传输，云端同步，实时分享',
        desc: '全网兼容，通过 4G 网络自动上传土壤数据至云端，随时下载，实时分享。'
      },
      tab6: {
        tips: '太阳能供电，无需布线',
        desc: '太阳能电池板供电，无需额外拉线，部署更灵活；超长续航，连续阴雨15天也能维持设备正常运转。',
        details: {
          item1: {
            title: '输入',
            value: '5~16V'
          },
          item2: {
            title: '输出',
            value: '15V/2A'
          },
          item3: {
            title: '电池容量',
            value: '7500mAh/7.4V'
          },
          item4: {
            title: '功率',
            value: '15W'
          },
          item5: {
            title: '工作温度',
            value: '-20~60℃'
          },
          item6: {
            title: '防护等级',
            value: 'IP67'
          },
          item7: {
            title: '主体重量',
            value: '1370g'
          },
          item8: {
            title: '主体尺寸',
            value: 'L401×W256×H35.4mm'
          }
        }
      },
      tab7: {
        tips: '多场景应用',
        case1: '温室大棚',
        case2: '蔬菜果园',
        case3: '污水处理',
        case4: '土壤速测',
        case5: '节水农业'
      },
      tab8: {
        title: '你可能还对以下产品感兴趣',
        item1: {
          title1: '极飞',
          title2: '',
          title3: 'IHUB1S 物联盒子'
        },
        item2: {
          title1: '极飞',
          title2: ' ',
          title3: 'IFC13S 农业智能相机'
        },
        item3: {
          title1: '极飞',
          title2: ' ',
          title3: 'IWS7S 农业气象站'
        },
        item4: {
          title1: '极飞',
          title2: ' ',
          title3: 'IWS3S 农业气象站'
        }
      },
      tab9: {
        title: '产品外观',
        weight: '重量 1150g'
      },
      details: {
        name: '产品参数',
        item1: {
          title: '工作电压',
          value: '5~15V'
        },
        item2: {
          title: '供电方式',
          value: '太阳能电池板/电源适配器 '
        },
        item3: {
          title: '工作温度 ',
          value: '-20~60℃ '
        },
        item4: {
          title: '防护等级',
          value: '主机部分 IP65/传感器部分 IP68'
        },
        item5: {
          title: '通讯方式',
          value: '4G/WiFi/蓝牙 '
        },
        item6: {
          title: '定位模式',
          value: 'GPS/基站定位 '
        },
        item7: {
          title: '支持运营商 ',
          value: '移动/联通/电信，内置电信贴片卡'
        },
        item8: {
          title: '温度测量范围 ',
          value: '-30~80℃ '
        },
        item9: {
          title: '土壤含水量测量范围',
          value: '0~100% '
        },
        item10: {
          title: '土壤电导率测量范围 ',
          value: '0~4mS/cm '
        },
        item11: {
          title: '温度测量精度 ',
          value: '±0.5℃ '
        },
        item12: {
          title: '土壤含水量测量精度 ',
          value: '±5% '
        },
        item13: {
          title: '土壤电导率测量精度 ',
          value: '±10%'
        }
      }
    },
    ws: {
      title1: '极飞',
      title2: '',
      title3: 'IWS7S 农业气象站',
      desc: '抓住小气候，精准把握农田脉搏',
      tab_nav: {
        item1: '概述',
        item2: '参数'
      },
      tab1: {
        item1: {
          tips: '全面监测',
          desc: '气象七要素一站式感知'
        },
        item2: {
          tips: '防水防尘',
          desc: 'IP65 防护等级'
        },
        item3: {
          tips: 'App 异常提醒',
          desc: '达到阈值主动通知'
        },
        item4: {
          tips: '云端管理',
          desc: 'GPS 定位，多终端随时查看'
        },
        item5: {
          tips: '太阳能电池',
          desc: '无需布线，无惧阴雨'
        },
        item6: {
          tips: '实时分享',
          desc: '4G 在线，同步分享'
        }
      },
      tab2: {
        tips: '气象七要素，一站式测量',
        desc: '集成气象站，不生锈、不蒙灰，精准测量气压、气温、湿度、光照、降雨量、风速、风向等气象七要素。',
        attr: {
          rainfall: {
            title: '降雨量',
            value: '±5%'
          },
          light: {
            title: '光照',
            value: '±15%'
          },
          wind_speed: {
            title: '风速',
            value: '±1m/s'
          },
          wind_direction: {
            title: '风向',
            value: '±22.5°'
          },
          temperature: {
            title: '温度',
            value: '±0.2℃',
            tips: ''
          },
          pressure: {
            title: '气压',
            value: '±4hPa'
          },
          humidity: {
            title: '湿度',
            value: '±5%',
            tips: ''
          }
        }
      },
      tab3: {
        tips: '防水防尘，室内室外都能用',
        desc: 'IP65 级防水防尘设计，无惧风吹日晒，适应室内室外各种环境。'
      },
      tab4: {
        tips: 'App 实时监测，异常情况，一目了然',
        desc: '当气象监测数据达到阈值时，App 管理平台将主动推送通知，提醒、指导用户及时处理。'
      },
      tab5: {
        tips: '足不出户，远程管理',
        desc: '内置 GPS 精准定位系统，通过手机 App 或电脑直观了解所有设备的安装位置，并随时随地查看气象情况。'
      },
      tab6: {
        tips: '4G 网络传输，云端同步，实时分享',
        desc: '全网兼容，通过 4G 网络自动上传气象数据至云端，随时分享。'
      },
      tab7: {
        tips: '太阳能供电，无需布线',
        desc: '太阳能电池板供电，无需额外拉线，部署更灵活；超长续航，连续阴雨15天也能维持设备正常运转。',
        details: {
          item1: {
            title: '输入',
            value: '5~16V'
          },
          item2: {
            title: '输出',
            value: '15V/2A'
          },
          item3: {
            title: '电池容量',
            value: '7500mAh/7.4V'
          },
          item4: {
            title: '功率',
            value: '15W'
          },
          item5: {
            title: '工作温度',
            value: '-20~60℃'
          },
          item6: {
            title: '防护等级',
            value: 'IP67'
          },
          item7: {
            title: '主体重量',
            value: '1370g'
          },
          item8: {
            title: '主体尺寸',
            value: 'L401×W256×H35.4mm'
          }
        }
      },
      tab8: {
        tips: '多种适用场景',
        case1: '农业监测',
        case2: '工业监管',
        case3: '大气环境监管',
        case4: '水文测量',
        case5: '火情监测'
      },
      tab9: {
        title: '你可能还对以下产品感兴趣',
        item1: {
          title1: '极飞',
          title2: '',
          title3: 'IHUB1S 物联盒子'
        },
        item2: {
          title1: '极飞',
          title2: ' ',
          title3: 'IFC13S 农业智能相机'
        },
        item3: {
          title1: '极飞',
          title2: ' ',
          title3: 'ISM50S 土壤监测仪'
        },
        item4: {
          title1: '极飞',
          title2: ' ',
          title3: 'IWS3S 农业气象站'
        }
      },
      tab10: {
        title: '产品外观',
        weight: '重量 550g'
      },
      details: {
        name: '产品参数',
        item1: {
          title: '工作电压',
          value: '5~15V'
        },
        item2: {
          title: '供电方式',
          value: '太阳能板供电/适配器供电 '
        },
        item3: {
          title: '工作温度 ',
          value: '-20~60℃ '
        },
        item4: {
          title: '防护等级',
          value: 'IP65'
        },
        item5: {
          title: '通讯方式',
          value: '4G/WiFi/蓝牙 '
        },
        item6: {
          title: '定位模式',
          value: 'GPS/基站定位 '
        },
        item7: {
          title: '支持运营商 ',
          value: '移动/联通/电信，内置电信贴片卡'
        },
        item8: {
          title: '温度测量范围 ',
          value: '-20~60℃'
        },
        item9: {
          title: '湿度测量范围',
          value: '0~100%RH'
        },
        item10: {
          title: '气压测量范围 ',
          value: '300～1100hPa  '
        },
        item11: {
          title: '降雨量测量范围 ',
          value: '0~200mm/h '
        },
        item12: {
          title: '光照测量范围 ',
          value: '1~125000Lux '
        },
        item13: {
          title: '风速测量范围 ',
          value: '0～15m/s '
        },
        item14: {
          title: '风向测量范围 ',
          value: '0～360° '
        },
        item15: {
          title: '温度测量精度 ',
          value: '±0.2℃'
        },
        item16: {
          title: '湿度测量精度',
          value: '±5%'
        },
        item17: {
          title: '气压测量精度 ',
          value: '±4hPa  '
        },
        item18: {
          title: '降雨量测量精度 ',
          value: '±5% '
        },
        item19: {
          title: '光照测量精度 ',
          value: '±15%  '
        },
        item20: {
          title: '风速测量精度 ',
          value: '±1m/s '
        },
        item21: {
          title: '风向测量精度 ',
          value: '±22.5° '
        }
      }
    },
    ht: {
      title1: '极飞',
      title2: ' ',
      title3: 'IWS3S 农业气象站',
      desc: '精准感知农田温湿',
      tab_nav: {
        item1: '概述',
        item2: '参数'
      },
      tab1: {
        item1: {
          tips: '精准温湿测量',
          desc: '体察植物细微感受'
        },
        item2: {
          tips: '防水防尘',
          desc: 'IP65 防护等级'
        },
        item3: {
          tips: 'App 异常提醒',
          desc: '达到阈值主动通知'
        },
        item4: {
          tips: '云端管理',
          desc: 'GPS 定位，多终端随时查看'
        },
        item5: {
          tips: '太阳能电池',
          desc: '无需布线，无惧阴雨'
        },
        item6: {
          tips: '实时分享',
          desc: '4G 在线，同步分享'
        }
      },
      tab2: {
        tips: '精准温湿度测量，细微体察精准',
        desc: '采用高灵敏温湿度传感器，精确感知 ± 0.2℃ 温度变化和 ± 5% 相对湿度变化，每隔 5 分钟测量一次，数据更精准。',
        attr: {
          temperature: {
            title: '温度',
            value: '±0.2℃',
            tips: ''
          },
          humidity: {
            title: '湿度',
            value: '±5%',
            tips: ''
          }
        }
      },
      tab3: {
        tips: '实时监控，冷暖干湿一览分明',
        desc: '通过 App 可随时查看农田、大棚温湿度数据及历史变化曲线，快速了解农田作物状况；当温湿度达到设定阈值时，将主动推送消息提醒用户。'
      },
      tab4: {
        tips: '防水防尘，无惧恶劣环境',
        desc: 'IP65 防护等级，采用高密度材质外壳及百叶箱设计，保护电路板和传感器，防水防尘效果好，使用寿命更长。'
      },
      tab5: {
        tips: '足不出户，远程管理',
        desc: '内置 GPS 精准定位系统，通过手机 App 或电脑直观了解所有设备的安装位置，并随时随地查看温湿度情况。'
      },
      tab6: {
        tips: '4G 网络传输，云端同步，实时分享',
        desc: '全网兼容，通过 4G 网络自动上传温湿度数据至云端，随时分享。'
      },
      tab7: {
        tips: '太阳能供电，无需布线',
        desc: '电阳能电池板供电，无需额外拉线，部署更灵活；超长续航，连续阴雨15天也能维持设备正常运转。',
        details: {
          item1: {
            title: '输入',
            value: '5~16V'
          },
          item2: {
            title: '输出',
            value: '15V/2A'
          },
          item3: {
            title: '电池容量',
            value: '7500mAh/7.4V'
          },
          item4: {
            title: '功率',
            value: '15W'
          },
          item5: {
            title: '工作温度',
            value: '-20~60 ℃'
          },
          item6: {
            title: '防护等级',
            value: 'IP67'
          },
          item7: {
            title: '主体重量',
            value: '1370g'
          },
          item8: {
            title: '主体尺寸',
            value: 'L401×W256×H35.4mm'
          }
        }
      },
      tab9: {
        tips: '应用场景',
        case1: '农业大棚',
        case2: '冷链物流',
        case3: '食物仓储',
        case4: '园艺种植'
      },
      tab10: {
        title: '你可能还对以下产品感兴趣',
        item1: {
          title1: '极飞',
          title2: '',
          title3: 'IHUB1S 物联盒子'
        },
        item2: {
          title1: '极飞',
          title2: '',
          title3: 'IFC13S 农业智能相机'
        },
        item3: {
          title1: '极飞',
          title2: '',
          title3: 'ISM50S 土壤监测仪'
        },
        item4: {
          title1: '极飞',
          title2: '',
          title3: 'IWS7S 农业气象站'
        }
      },
      tab11: {
        title: '产品外观',
        weight: '重量 463g'
      },
      details: {
        name: '产品参数',
        item1: {
          title: '工作电压',
          value: '5~15V'
        },
        item2: {
          title: '供电方式',
          value: '太阳能电池板/电源适配器 '
        },
        item4: {
          title: '防护等级',
          value: 'IP65'
        },
        item5: {
          title: '通讯方式',
          value: '4G/WiFi/蓝牙 '
        },
        item6: {
          title: '定位模式',
          value: 'GPS/基站定位 '
        },
        item7: {
          title: '支持运营商 ',
          value: '移动/联通/电信，内置电信贴片卡'
        },
        item8: {
          title: '温度测量范围 ',
          value: '-20~60℃ '
        },
        item9: {
          title: '湿度测量范围',
          value: '0~100%RH'
        },
        item10: {
          title: '光照测量范围 ',
          value: '1~125000Lux  '
        },
        item11: {
          title: '温度测量精度 ',
          value: '±0.2℃'
        },
        item12: {
          title: '湿度测量精度 ',
          value: '±5% '
        },
        item13: {
          title: '光照测量精度 ',
          value: '±15%  '
        }
      }
    },
    ihub: {
      title1: '极飞',
      title2: '',
      title3: 'IHUB1S 物联盒子',
      desc: '实现设备间的智能联动',
      tab_nav: {
        item1: '概述',
        item2: '参数'
      },
      tab1: {
        pre_tips: 'RS485协议接口',
        tips: '有线接口，拓展无忧',
        desc: '通过RS485协议接口，支持连接多达32个模块，实现更稳定的产品互联',
        details: {
          item1: {
            title: 'RS485',
            value: '协议接口'
          },
          item2: {
            title: '32',
            value: '模块接入'
          }
        }
      },
      tab2: {
        pre_tips: '多种添加方式',
        tips: '添加连接，更多可能性',
        desc: '支持行业内的传感、控制等模块，并且随着硬件平台的扩展而实时更新可连接的模块，多种添加方式，轻松连接多种模块',
        details: {
          item1: {
            title: '自动添加'
          },
          item2: {
            title: '快速添加'
          },
          item3: {
            title: '自定义添加'
          }
        }
      },
      tab3: {
        pre_tips: '工作流模式',
        tips: '玩转联动，打造自动化',
        desc: '与极飞稻草人接入，轻松搭建自动化流程，打造高稳定，标准化的农田自动化方案'
      },
      tab4: {
        pre_tips: '数据管理',
        tips: '数据可视化，实时查询',
        desc: '通过各传感器数据收集，在极飞稻草人app中存储各类型数据，支持实时查询，适用于农事监管'
      },
      tab11: {
        title: '你可能还对以下产品感兴趣',
        item1: {
          title1: '极飞',
          title2: '',
          title3: 'IFC13S 农业智能相机'
        },
        item2: {
          title1: '极飞',
          title2: ' ',
          title3: 'ISM50S 土壤监测仪'
        },
        item3: {
          title1: '极飞',
          title2: ' ',
          title3: 'IWS7S 农业气象站'
        },
        item4: {
          title1: '极飞',
          title2: ' ',
          title3: 'IWS3S 农业气象站'
        }
      },
      tab12: {
        title: '',
        weight: ''
      },
      details: {
        name: '产品参数',
        item1: {
          title: '工作电压',
          value: 'DC5-15V'
        },
        item2: {
          title: '工作温度',
          value: '-20~60℃ '
        },
        item3: {
          title: '主体尺寸 ',
          value: 'L125*W75*H27mm '
        },
        item4: {
          title: '供电方式',
          value: '太阳能板供电/适配器供电'
        },
        item5: {
          title: '防护等级',
          value: 'IP66 '
        },
        item6: {
          title: '浪涌等级',
          value: '2.0KV '
        },
        item7: {
          title: '对外硬件接口 ',
          value: 'RS485/USB'
        },
        item8: {
          title: 'RS485接口输出电压 ',
          value: '12V'
        },
        item9: {
          title: 'RS485接口通信协议',
          value: 'modbus-rtu协议 '
        },
        item10: {
          title: 'RS485接口支持节点数',
          value: '256 '
        },
        item11: {
          title: '通讯方式',
          value: '4G/WIFI '
        }
      }
    },
    parts: {
      solar: {
        title: '太阳能充电板',
        desc1: '提供户外简单便捷的',
        desc2: '供电方式',
        tab1: {
          title: '产品外观',
          weight: '重量 1370g'
        },
        details: {
          name: '产品参数',
          item1: {
            title: '输入',
            value: '5～16V'
          },
          item2: {
            title: '输出',
            value: '15V/2A'
          },
          item3: {
            title: '电池容量',
            value: '7500mAh/7.4V'
          },
          item4: {
            title: '太阳能板功率',
            value: '15W '
          },
          item5: {
            title: '工作温度',
            value: '-20～60℃ '
          },
          item6: {
            title: '防水防尘 ',
            value: 'IP67'
          }
        }
      },
      fixedbanister: {
        title: '固定立杆',
        desc: '安装简易、快速部署',
        tab1: {
          title: '产品外观',
          weight: '重量 3200g'
        },
        details: {
          name: '产品参数',
          weight: {
            title: '重量',
            value: '5.3KG'
          },
          size: {
            title: '尺寸',
            value: '145*145*1200mm'
          }
        }
      },
      bisectwire: {
        title: '一分二电源线',
        desc: '一进二出，扩展更多设备',
        tab1: {
          title: '产品外观',
          length: '1.53m'
        },
        details: {
          name: '产品参数',
          item1: {
            title: '工作电压',
            value: '5～15V'
          },
          item2: {
            title: '防护等级',
            value: 'IP67'
          }
        }
      }
    }
  },
  //  开放平台
  api: {
    name: '开放平台',
    desc: '为用户提供稳定、安全和高效的数据接口，以及灵活的硬件接入方式，满足用户个性化的业务需求',
    tab1: {
      tips: '数据服务',
      desc1: '基于 HTTPS 协议，',
      desc2: '为应用系统提供安全易用的数据接口'
    },
    tab2: {
      tips: '硬件设备',
      desc: '支持 RS485、HTTP 和 SDK 多种方式接入方式'
    },
    tab3: {
      tips: '如何成为开发者',
      steps1: {
        name: '注册账号'
      },
      steps2: {
        name: '申请授权'
      },
      steps3: {
        name: '完成授权'
      }
    }
  },
  // 软件
  software: {
    app: {
      title: '极飞稻草人',
      desc: '为用户提供简单快捷的管理方式',
      btn1: 'APP',
      btn2: '小程序',
      btn3: '网页版',
      tab1: {
        tips: '设备管理',
        desc: '扫码关注，快速了解设备运行状态'
      },
      tab2: {
        tips: '协助管理',
        desc: '随时查看作物生长环境数据信息，设置数据提醒进行有效监控'
      },
      tab3: {
        tips: '连接用户',
        desc: '数据分享、产品追溯，建立用户和农场的连接'
      },
      tab4: {
        tips: '智能互联',
        desc: '扫描设备底部或右边二维码或前往“华为/小米应用商店”“苹果App Store”下载安装“极飞稻草人“App”'
      },
      tab5: {
        tips: '数据管理',
        desc: '针对企业或多设备用户提供更高效的PC端管理工具'
      }
    },
    fmadmin: {
      title: '数据管理',
      desc: '针对企业或多设备用户提供更高效的PC端管理工具',
      tab1: {
        tips: '设备管理',
        desc: '直观查看设备运行状态和分布情况'
      },
      tab2: {
        tips: '数据展示',
        desc: '可查看和下载一年内历史采集数据'
      }
    }
  },
  // 安装教程
  installs: {
    return: '返回',
    download: '文档下载',
    fm1: {
      name: 'FM1安装教程',
      items1: {
        name: '固定太阳能板',
        item1: '1、先将配套的螺母和螺帽插入太阳能板支架',
        item2: '2、然后将太阳能板连同支架整体通过上半截杆子顶部套入到中部位置。杆子缺口处对准太阳板方向',
        item3: '3、将太阳板上的电线通过杆子缺口穿到上端开口处',
        item4: '4、锁紧螺母螺帽，固定住',
        tips: '注意杆子的缺口处对准太阳能板方向'
      },
      items2: {
        name: '开机',
        item1: '1、打开FM1头部底面靠前的小硅胶盖子，注意看到里面右上角有一个白色圆形小按钮，请将开关按下通电，等待指示灯点亮，完成开机',
        tips: '使用小于开机孔径的硬物按下即可'
      },
      items3: {
        name: '锁定FM1头部',
        item1: '1、将FM1头部插入上半截杆子顶部',
        item2: '2、用螺丝拧紧'
      },
      items4: {
        name: '连接上下两根杆子',
        item1: '1、将上半截杆子插入下半截杆子',
        item2: '2、用螺丝拧紧'
      },
      items5: {
        name: '固定杆子底部',
        item1: '1、打水泥桩',
        item2: '2、调节好FM1方向，对准农作物',
        item3: '3、锁紧水泥桩和杆子底盘的螺母和螺帽'
      },
      pdf: 'FM1安装教程PDF'
    },
    fm2: {
      name: 'FM2安装教程',
      items1: {
        name: '固定太阳能板',
        item1: '1、接太阳板电源线，而后将航空座放入立杆管内',
        item2: '2、太阳能板支架套在立杆上，杆子缺口处对准太阳板方向位置如图所示，同时锁紧螺丝',
        tips: '注意杆子的缺口处对准太阳能板方向'
      },
      items2: {
        name: '开机',
        item1: '1、打开FM2头部底面靠前的小硅胶盖子，插入SIM卡，按下电源开关后，指示灯常亮即检查到SIM卡，完成开机，若指示灯在闪，则需要重新检查SIM卡',
        tips: '使用小于开机孔径的硬物按下即可'
      },
      items3: {
        name: '安装FM2主机',
        item1: '1、将FM2主机插好电源线后，套在立杆上，锁紧螺丝'
      },
      items4: {
        name: '连接上下两根杆子',
        item1: '1、将上半截杆子插入下半截杆子',
        item2: '2、用螺丝拧紧'
      },
      items5: {
        name: '固定杆子底部，调整主机和太阳方向',
        item1: '1、打水泥桩',
        item2: '2、调节FM2主机方向，将有LOGO“XAIRCRAFT”面朝正北',
        item3: '3、调节太阳板方向，将太阳板朝正南（南半球），同时太阳板向下倾斜20-30度角',
        item4: '4、锁紧水泥桩和杆子底盘的螺母和螺帽'
      },
      aution1: {
        name: '设备安装的选址要求',
        item1: '1、降水量观测误差受风的影响最大，因此，安装场地应避开强风区，使其周围空旷、平坦、不受突变地形、树木和建筑物以及烟尘的影响。',
        item2: '2、安装场地不能完全避开建筑物、树木等障碍物的影响时，设备离开障碍物边缘的距离不应小于障碍物顶部与仪器口高差的2倍。'
      },
      aution2: {
        name: '土壤水分传感器安装注意事项',
        item1: '1、探针应与土壤紧密接触，插入时请勿摇晃传感器。',
        item2: '2、应避开土壤中的石块等异物，或将异物移去再重新插入，以防损坏探针。',
        item3: '3、建议安装方式，如下图：'
      },
      autionTips: {
        item1: '1、在地上挖一个洞',
        item2: '2、将传感器横向插入土壤中',
        item3: '3、将洞回填'
      },
      pdf: 'FM2安装教程PDF'
    },
    fc1: {
      name: ' 农业智能相机安装教程',
      items1: {
        name: '开机',
        item1: '1、拧开后盖，按标识插Nano-SIM卡',
        item2: '2、按电源开关，指示灯显绿色，稍后显橙色，即完成开机',
        item3: '3、拧紧后盖,避免设备进水后损坏',
        tips: '指示灯说明',
        moreInfo: {
          attr1: '工作模式',
          value1: '橙灯',
          attr2: '休眠模式',
          value2: '绿灯',
          attr3: '故障：联网不成功',
          value3: '橙灯慢闪烁',
          attr4: '故障：检查不到SIM卡',
          value4: '橙灯快闪烁'
        }
      },
      items2: {
        name: '安装支架',
        item1: '1、选好安装位置，将安装支架固定在立杆上'
      },
      items3: {
        name: '主机安装',
        item1: '1、调节支架角度,将摄像头对准实物,拧紧螺丝'
      },
      items4: {
        name: '接线和检查',
        item1: '1、将太阳板插座对好相机后盖插座后,拧紧，如左下图所示',
        item2: '2、将尾座硅胶套塞紧后盖,如右下图所示',
        item3: '3、检查后盖、尾座硅胶套是否松动,拧紧则可',
        item4: '4、检查镜头前罩外是否有污点,无污点则可,并定期清洗',
        item5: {
          part1: '5、检查太阳能板充电情况，查看太阳能板背面的充电灯是否亮起。也可以扫描首页二维码进入"极飞稻草人"小程序，显示有',
          part2: '标志即代表充电正常。'
        }
      },
      items5: {
        name: '外观介绍'
      },
      items6: {
        name: '产品清单'
      },
      pdf: ' 农业智能相机安装教程PDF'
    },
    fc2: {
      name1: '极飞',
      name: 'IFC13S 农业智能相机安装教程',
      items1: {
        name: '安装SIM卡',
        item1: '1、拔出SIM卡盖，将Nano-SIM卡插入SIM卡槽，盖回SIM卡盖。',
        tips: 'Nano-SIM卡安装方向，请参考下图。此产品有内置 SIM 卡，不插卡也可以联网，但需要在极飞稻草人 APP 中开通数据服务。'
      },
      items2: {
        name: '安装支架',
        item1: '1、将支架固定到立杆的管箍上，用管箍自带的4颗螺钉固定，拧紧螺钉即可。'
      },
      items3: {
        name: '安装主机',
        item1: '1、调节支架角度，将摄像头对准实物，拧紧螺丝。',
        item2: '2、将电源连接线一端插入主机电源接口，另一端接太阳能板输出接口。'
      },
      items4: {
        name: '开机',
        item1: '1、按电源开关，三个指示灯按照电源指示灯 > 状态指示灯 > 信号指示灯的顺序依次亮起，三个灯全部亮起，则完成开机。',
        tips: {
          name: '指示灯说明',
          item1: '指示灯常亮',
          item2: '指示灯闪烁',
          item3: '指示灯熄灭'
        },
        moreInfo: {
          attr1: '工作模式',
          value1: '蓝灯',
          method1: '',
          attr2: '休眠或待机模式',
          value2: '灯灭',
          method2: '按电源开关键恢复工作模式',
          attr3: '故障：检测不到SIM卡',
          value3: '状态指示灯闪烁',
          method3: '检查SIM卡是否有效且正确安装',
          attr4: '故障：联网不成功',
          value4: '信号指示灯闪烁',
          method4: '检查设备所在位置是否在运营商信号覆盖范围内，并重新启动传感器设备'
        },
        item2: '2、检查镜头前罩外是否有污点，并定期清洗。',
        item3: '3、检查设备是否固定，螺丝必须拧紧，设备不能晃动。',
        item4: {
          part1: '4、检查太阳能板充电情况，查看太阳能板背面的充电灯是否亮起。也可以扫描首页二维码进入"极飞稻草人"小程序，显示有',
          part2: '标志即代表充电正常。'
        }
      },
      pdf: 'IFC13S 农业智能相机安装教程PDF'
    },
    sm: {
      name1: '极飞',
      name: 'ISM50S 土壤监测仪安装教程',
      items1: {
        name: '安装SIM卡',
        item1: '1、使用L形扳手拧开SIM卡盖两侧的螺丝，取掉卡盖，插入SIM卡，然后盖回SIM卡盖，拧紧螺丝。',
        tips: 'Nano-SIM卡安装方向，请参考下图。此产品有内置 SIM 卡，不插卡也可以联网，但需要在极飞稻草人APP中开通数据服务。'
      },
      items2: {
        name: '安装设备',
        item1: '1、使用电源连接线连接太阳能板和传感器设备。电源连接线一端接太阳能板输出口，另一端接传感器设备电源接口。',
        item2: '2、使用取土铲在选定位置的地面挖坑，将传感器设备埋入坑中，保证设备上的地面线与地面平齐。'
      },
      items3: {
        name: '检查并开机',
        item1: '1、按电源开关，三个指示灯按照电源指示灯 > 状态指示灯 > 信号指示灯 的顺序依次亮起，三个灯全部亮起，则完成开机。',
        tips: {
          name: '指示灯说明',
          item1: '指示灯常亮',
          item2: '指示灯闪烁',
          item3: '指示灯熄灭'
        },
        moreInfo: {
          attr1: '工作模式',
          value1: '蓝灯',
          method1: '',
          attr2: '休眠或待机模式',
          value2: '灯灭',
          method2: '按电源开关键恢复工作模式',
          attr3: '故障：检测不到SIM卡',
          value3: '状态指示灯闪烁',
          method3: '检查SIM卡是否有效且正确安装',
          attr4: '故障：联网不成功',
          value4: '信号指示灯闪烁',
          method4: '检查设备所在位置是否在运营商信号覆盖范围内，并重新启动传感器设备'
        },
        item2: '2、检查传感器设备是否填埋正确，设备地面线需要与地面平齐。',
        item3: '3、检查传感器设备是否固定，设备必须填埋紧实,不能晃动。',
        item4: '4、检查电源连接线是否松动，插紧即可。',
        item5: {
          part1: '5、检查太阳能板充电情况，查看太阳能板背面的充电灯是否亮起。也可以扫描首页二维码进入"极飞稻草人"小程序，显示有',
          part2: '标志即代表充电正常。'
        }
      },
      pdf: 'ISM50S 土壤监测仪安装教程PDF'
    },
    ws: {
      name1: '极飞',
      name: 'IWS7S 农业气象站安装教程',
      items1: {
        name: '安装SIM卡',
        item1: '1、使用L形扳手拧开SIM卡盖两侧的螺丝，取掉卡盖，插入SIM卡，然后盖回SIM卡盖，拧紧螺丝。',
        tips: 'Nano-SIM卡安装方向，请参考下图。此产品有内置SIM卡，不插卡也可以联网，但需要在极飞稻草人 APP 中开通数据服务。'
      },
      items2: {
        name: '安装支架 ',
        item1: '1、将支架固定安装到立杆的管箍上，用管箍自带的4颗螺钉固定，拧紧螺钉即可。',
        item2: '2、将电源连接线从支架中穿过，如下图所示。'
      },
      items3: {
        name: '接线和固定',
        item1: '1、将电源连接线一端插入主机电源接口，另一端插入太阳能板的电源输出接口，如下图所示。',
        item2: '2、将传感器设备安装在支架上，使用L形扳手锁紧4颗附带的螺丝。'
      },
      items4: {
        name: '检查并开机',
        item1: '1、按电源开关 ，三个指示灯按照电源指示灯 > 状态指示灯 > 信号指示灯 的顺序依次亮起，三个灯全部亮起，则完成开机。',
        tips: {
          name: '指示灯说明',
          item1: '指示灯常亮',
          item2: '指示灯闪烁',
          item3: '指示灯熄灭'
        },
        moreInfo: {
          attr1: '工作模式',
          value1: '蓝灯',
          method1: '',
          attr2: '休眠或待机模式',
          value2: '灯灭',
          method2: '按电源开关键恢复工作模式',
          attr3: '故障：检测不到SIM卡',
          value3: '状态指示灯闪烁',
          method3: '检查SIM卡是否有效且正确安装',
          attr4: '故障：联网不成功',
          value4: '信号指示灯闪烁',
          method4: '检查设备所在位置是否在运营商信号覆盖范围内，并重新启动传感器设备'
        },
        item2: '2、检查电源连接线是否松动，插紧即可。',
        item3: '3、检查传感器设备是否固定，螺丝必须拧紧，设备不能晃动。',
        item4: {
          part1: '4、检查太阳能板充电情况，查看太阳能板背面的充电灯是否亮起。也可以扫描首页二维码进入"极飞稻草人"小程序，显示有',
          part2: '标志即代表充电正常。'
        }
      },
      pdf: 'IWS7S 农业气象站安装教程PDF'
    },
    ht: {
      name1: '极飞',
      name: 'IWS3S 农业气象站安装教程',
      items1: {
        name: '安装SIM卡',
        item1: '1、使用L形扳手拧开SIM卡盖两侧的螺丝，取掉卡盖，插入SIM卡，然后盖回SIM卡盖，拧紧螺丝。',
        tips: 'Nano-SIM卡安装方向，请参考下图。此产品有内置SIM卡，不插卡也可以联网，但需要在极飞稻草人APP中开通数据服务。'
      },
      items2: {
        name: '安装支架',
        item1: '1、将支架固定安装到立杆的管箍上，用管箍自带的4颗螺钉固定，拧紧螺钉即可。',
        item2: '2、将电源连接线从支架中穿过，如下图所示。'
      },
      items3: {
        name: '接线和固定',
        item1: '1、将电源连接线一端插入主机电源接口，另一端插入太阳能板的电源输出接口，如下图所示。',
        item2: '2、将传感器设备安装在支架上，使用L形扳手锁紧3颗附带的螺丝。'
      },
      items4: {
        name: '检查并开机',
        item1: '1、按电源开关，三个指示灯按照电源指示灯 > 状态指示灯 > 信号指示灯 的顺序依次亮起，三个灯全部亮起，则完成开机。',
        tips: {
          name: '指示灯说明',
          item1: '指示灯常亮',
          item2: '指示灯闪烁',
          item3: '指示灯熄灭'
        },
        moreInfo: {
          attr1: '工作模式',
          value1: '蓝灯',
          method1: '',
          attr2: '休眠或待机模式',
          value2: '灯灭',
          method2: '按电源开关键恢复工作模式',
          attr3: '故障：检测不到SIM卡',
          value3: '状态指示灯闪烁',
          method3: '检查SIM卡是否有效且正确安装',
          attr4: '故障：联网不成功',
          value4: '信号指示灯闪烁',
          method4: '检查设备所在位置是否在运营商信号覆盖范围内，并重新启动传感器设备'
        },
        item2: '2、检查电源连接线是否松动，插紧即可。',
        item3: '3、检查传感器设备是否固定，螺丝必须拧紧，设备不能晃动。',
        item4: {
          part1: '4、检查太阳能板充电情况，查看太阳能板背面的充电灯是否亮起。也可以扫描首页二维码进入"极飞稻草人"小程序，显示有',
          part2: '标志即代表充电正常。'
        }
      },
      pdf: 'IWS3S 农业气象站安装教程PDF'
    },
    solar: {
      name: '太阳能板安装教程',
      items1: {
        name: '安装太阳能板',
        item1: '1、将支架放入太阳能板的支架安装槽内，使用L形扳手拧紧4颗M3螺丝。',
        item2: '2、将提前固定在立杆上的管箍连接端的4颗螺丝拧下，然后把带支架的太阳能板安装在管箍上，使支架连接端的4个螺丝孔与管箍上的螺丝孔对齐，装入取下的4颗螺丝，用L形扳手拧紧即可。',
        item3: '3、调节太阳能板方向。拧松管箍固定螺丝 ，旋转太阳能板，使太阳板朝向正南（北半球）后拧紧管箍固定螺丝。拧松太阳能板固定螺丝 ，转动太阳板，使之向地面倾斜20-30度角后拧紧太阳能板固定螺丝。',
        tips: '固定太阳能板支架时，太阳能面板需要朝向上方 。'
      },
      pdf: '太阳能充电板安装教程PDF'
    },
    // 配件
    accessories: {
      name: '配件清单',
      item1: '内六角扳手1',
      item2: '内六角扳手2',
      item3: '开口扳手',
      item4: 'M6*8内六角圆柱头螺钉',
      item5: 'M6*10内六角沉头螺钉',
      item6: '内膨胀螺丝',
      item_1: '六边形对边4*29*74（1个）',
      item_2: '六边形对边5*30*80（1个）',
      item_3: '六边形对边13*87*2（1个）',
      item_4: 'M6*8（3颗）',
      item_5: 'M6*10（4颗）',
      item_6: 'M10*L100(4个)'
    },
    // 户外立杆安装
    fixedpole: {
      name: '立杆户外安装教程',
      items1: {
        name: '户外环境 一： 安装在水泥地面',
        item1: '1、制作底座（用 DN32 镀锌管，壁厚 3.5mm 与一块 210*210mm 方块焊接），如下图一所示，详细图纸请参考附件 1；',
        item2: '2、在水泥地面上安装底座，钻孔埋入 4 个 M6*80 膨胀螺丝，将以上底座安装上去，如下图二所示；',
        item3: '3、将立杆套进底座内，在立杆底部锁两颗 M6 螺丝固定。如下图三所示.'
      },
      items2: {
        name: '户外环境二：安装在 水田',
        item1: '1、制作水泥桩，中心预留立杆孔（直径 35mm，深 300mm），如下图四所示；',
        item2: '2、将水泥桩埋于土壤内，掩埋水泥桩，使其稳固，如下图五所示；',
        item3: '3、将主机立杆插入水泥桩内，再用泥图掩埋，如下图六所示；'
      },
      items3: {
        name: '户外环境三 ：安装在山地',
        item1: '1、制作底座（用 DN32 镀锌管，壁厚 3.5mm 与一块 210*210mm 方块焊接），如下图七所示，图纸请参考附件 2；',
        item2: '2、将带有底座的立杆埋在土壤底下约 400mm，具体深度依据土质决定，如下图八所示。',
        item3: '3、并将立杆套进底座内，在立杆底部锁两颗 M6 螺丝固定。如下图九所示；'
      },
      pdf: '立杆户外安装教程PDF'
    }
  },
  // 产品指南
  guide: {
    title: '产品指南',
    desc: '让您更好使用产品',
    installs: {
      item1: 'IFC16S 农业智能相机安装教程',
      item2: 'ISM50 土壤监测仪安装教程',
      item3: 'IWS7 农业气象站安装教程',
      item4: 'IWS3 农业气象站安装教程',
      item5: 'IFC16 农业智能相机安装教程',
      item6: 'FM2 安装教程',
      item7: 'FM1 安装教程',
      item8: '太阳能充电板安装教程',
      item9: '立杆户外安装教程'
    },
    more: '更多'
  },
  // 问答
  questions: {
    name: '常见问题',
    desc: '为您解答所有问题',
    faq: '常见问题解答',
    item1: {
      q: '点击“我的设备”无法进入小程序？',
      a: '由于旧版本微信不支持小程序，请更新微信至最新版本。'
    },
    item2: {
      q: '设备开机后无法连网？',
      a: '开机后查看设备指示灯，绿灯一直闪烁表示设备没有检测到SIM卡，请检查SIM卡安装是否正确。'
    },
    item3: {
      q: '为什么在小程序里无法修改设备名称？',
      a: '只有设备管理者才能修改设备名称。'
    },
    item4: {
      q: '如何成为设备管理者？',
      a: '设备在没有被使用过的情况下，第一个扫描添加设备的用户将成为设备管理者；在设备已有管理者的情况下，需当前设备管理者删除设备，然后新用户重新扫描添加设备即成为管理者。'
    },
    item5: {
      q: '为什么图像会有模糊情况？',
      a: '图像模糊是由于当时环境光线太强导致摄像头无法正常对焦。解决办法，安装设备时尽量避免阳光直接照射到镜头；在设备参数设置里，将图像亮度参数调低。'
    },
    item6: {
      q: '为什么“全日时景”里的视频会抖动？',
      a: '在默认设备参数情况下，设备可能会受到环境光线或景物影响导致某时刻拍摄的图像发生变化。设备安装完成后，在设备参数里，将拼接模式设置为保持。'
    },
    item7: {
      q: '为什么设备工作一段时间后离线？',
      a1: '导致设备离线主要有两个原因：',
      a2: '1、设备安装位置信号不稳定。解决办法，将设备移至信号稳定区域安装。',
      a3: '2、设备供电电池没电，通常由于太阳能板安装不正确导致。解决办法，将太阳能板调整至朝南向，增加太阳照射时间以获得最大转化效率。'
    }
  },
  // 售后服务
  afterMarket: {
    name: '售后服务',
    desc: '为您提供安心保障',
    flow: {
      name: '售后流程',
      step1: {
        step: '01',
        title: '注册账号',
        desc: '进入微信小程序“极飞服务”注册账号'
      },
      step2: {
        step: '02',
        title: '故障报修',
        desc: '选择“故障报修入口”'
      },
      step3: {
        step: '03',
        title: '填写信息',
        desc: '填写设备信息及故障问题'
      },
      step4: {
        step: '04',
        title: '完成',
        desc: '确定完成后即可等待工作人员反馈'
      }
    },
    info: {
      name: '售后信息',
      staff: '维修人员:',
      staffName: '景代敏',
      address: '东莞大岭山连平村莞长路力桑工业园 极飞科技',
      express: '售后快递',
      tel: '18925499895'
    },
    moreInfo: '更多售后详情请了解',
    document: '售后协议'
  },
  // 文档下载
  download: {
    name: '文档下载',
    faq: '设备安装及软件使用',
    products: {
      name: '产品简介',
      fc2: 'IFC16S 农业智能相机产品简介',
      sm: 'ISM50 土壤监测仪产品简介',
      ws: 'IWS7 农业气象站安装教程产品简介',
      ht: 'IWS3 农业气象站产品简介',
      fc1: 'IFC16 农业智能相机产品简介',
      fm1: 'FM1产品简介',
      fm2: 'FM2产品简介'
    },
    install: {
      name: '安装教程',
      fc2: 'IFC16S 农业智能相机安装教程',
      sm: 'ISM50 土壤监测仪安装教程',
      ws: 'IWS7 农业气象站安装教程',
      ht: 'IWS3 农业气象站安装教程',
      fc1: 'IFC16 农业智能相机安装教程',
      fm1: 'FM1安装教程',
      fm2: 'FM2安装教程',
      solar: '太阳能板安装教程',
      fixedpole: '立杆户外安装教程'
    },
    specifications: {
      name: '产品参数',
      ihub1s: 'IHUB1S 物联盒子产品参数',
      ifc13s: 'IFC13S 农业智能相机产品参数',
      iws3s: 'IWS3S 农业气象站产品参数',
      iws7s: 'IWS7S 农业气象站产品参数',
      ism50s: 'ISM50S 土壤监测仪产品参数',
      itl: 'ITL 农机盒子产品参数',
      itlpro: 'ITL Pro 农机盒子产品参数',
      fc2: 'IFC16S 农业智能相机产品参数',
      sm: 'ISM50 土壤监测仪产品参数',
      ws: 'IWS7 农业气象站产品参数',
      ht: 'IWS3 农业气象站产品参数',
      solar: '太阳能板产品参数'
    },
    btn: '下载'
  },
  footer: {
    copyright: '极飞科技 保留所有权利。',
    miit: '(粤ICP备13085628号)'
  },
  // 页面建设中
  building: {
    title: '页面正在努力建设中',
    desc: '即将开放，敬请期待',
    back: '回首页'
  },
  // 404页面
  pageUndefinded: {
    title: '404',
    desc: '页面不存在'
  },
  filter: {
    hour: '小时',
    minute: '分',
    second: '秒',
    rightNow: '刚刚',
    minuteAgo: '分钟前',
    today: '今天',
    yesterday: '昨天'
  },
  components: {
    sliderDefault: '请将滑块拖动到最右边，完成验证',
    sliderIsEnd: '完成验证',
    inputGroupPasteError: '仅支持输入数字'
  },
  // 登录页 signin
  signin: {
    backToIndex: '返回首页',
    account: '账号登录',
    tel: '手机登录',
    wechat: '微信登录',
    thirdMethod: '第三方登录方式',
    wechatThirdMethod: '微信',
    accountPlaceholder: '用户名/邮箱/手机号',
    pswPlaceholder: '密码',
    telPlaceholder: '手机号码',
    areaCodePlaceholder: '请选择',
    getVcodeText: '获取验证码',
    getVcodeTextLater: '重新发送({ticker}s)',
    verificationCodePlaceholder: '请输入验证码',
    accountLoginError: '账号或密码错误',
    telLoginError: '手机号或验证码错误',
    signin: '登录',
    forgetPsw: '忘记密码',
    registerAccount: '注册',
    loginAgreeTips: '登录即同意',
    userService: '《用户服务协议》',
    userPrivate: '《隐私条款》',
    // 字段验证 规则错误
    accountEmptyError: '请输入用户名/邮箱/手机号',
    pswEmptyError: '请输入密码',
    telEmptyError: '请输入手机号',
    VcodeEmptyError: '请输入验证码',
    telFormatError: '请输入正确的手机号'
  },
  // signup 注册页
  signup: {
    applyAccount: '申请账号',
    hasAccount: '已有账号',
    toLogin: '登录',
    exitApply: '退出',
    // 注册
    accountPlaceholder: '用户名',
    accountFormatTips: '6-24位字母/数字组合',
    accountEmptyError: '请输入用户名',
    accountExistError: '该用户名已被使用，请输入其他用户名',
    accountFormatError: '用户名为6-24位数字、字母组合，不能为纯数字',
    pswPlaceholder: '密码',
    pswFormatTips: '8-24位数字、字母或常用符号',
    pswFormatError: '密码输入格式有误，请重新输入',
    pswEmptyError: '密码不可为空',
    pswConfirmPlaceholder: '确认密码',
    pswConfirmError: '两次密码输入不一致，请重新输入',
    emailPlaceholder: '邮箱',
    emailEmptyError: '邮箱不可为空',
    emailFormatError: '邮箱输入格式有误，请重新输入',
    emailExistError: '该邮箱已被使用，请重新输入',
    accpetPrivacyTips1: '我已阅读并接受',
    accpetPrivacyTips2: '《隐私条款》',
    accpetPrivacyError: '我已阅读并同意《用户服务协议、《隐私条款》',
    toRegister: '立即申请',
    emailSendedTitle: '身份验证，完成注册',
    emailSendedTips1: '验证码已发送至您输入的邮箱 {email}，请注意查收并在下方填写',
    emailSendedNoRecicve: '没有收到？',
    emailSendedResend: '重新发送',
    toActive: '确认'
  },
  // forgetPsw 忘记密码
  forgetPsw: {
    getBackPasswordTitle: '找回密码',
    rememberPassword: '想起密码，',
    toLogin: '登录',
    toUser: '返回',
    accountPlaceholder: '用户名/邮箱/手机号',
    accountEmptyError: '请输入用户名/邮箱/手机号',
    nextBtn: '下一步',
    vcodeSendedTitle: '身份验证，找回密码',
    vcodeSendedTips1: '验证码已发送至 ',
    vcodeSendedTips2: '，请注意查收并在下方填写',
    telVerify: '手机',
    emailVerify: '邮箱',
    vcodeSendedNoRecicve: '没有收到？',
    vcodeSendedResend: '重新发送',
    // 重置密码
    resetPswTitle: '重置密码',
    pswPlaceholder: '密码',
    pswFormatTips: '8-24位数字、字母或常用符号',
    pswEmptyError: '密码不可为空',
    pswFormatError: '密码格式有误，请重新输入',
    pswConfirmPlaceholder: '确认密码',
    pswConfirmError: '两次密码输入不一致，请重新输入',
    reserBtn: '确定'
  },
  // 账号注销页
  delete: {
    back: '返回',
    out: '退出',
    deleteTitle: '申请注销',
    deleteTipsTitle: '你正在申请注销极飞稻草人账号',
    deleteTipsDesc: '账号注销后不可恢复，请你谨慎操作。注销成功后，你在极飞稻草人上的所有个人数据、信息、权益将被清空，无法找回，包括但不限于以下内容：',
    deleteTipsLine1: '1、你的账号空间存储量将被清零；',
    deleteTipsLine2: '2、你的兑换券将被清零；',
    deleteTipsLine3: '3、你的订单购买记录将被清除，无法开具发票；',
    deleteTipsLine4: '4、你的硬件平台模块列表将被清除。',
    deleteDeleteBtn: '已清楚风险，确定注销',
    deleteSuccessTitle: '已完成账号注销申请',
    deleteSuccessDesc: '账号将在15天后自动注销，所有数据将被删除。请不要在此时间段登录，以确保注销顺利完成。'
  },
  // 社区
  community: {
    // 社区主页
    index: {
      emptyPost: '还没有话题发布，快前往 “社区” 发表新话题吧',
      allPost: '所有话题',
      newPost: '新话题',
      searchPostPlaceholder: '请输入搜索内容',
      searchPostResult: '搜索结果：找到与 <span style="color:#4580fe">“{key}”</span> 相关的内容 {num} 个',
      pageGo: '前往',
      lastModifiled: '最后编辑于',
      deletedAccount: '账号已注销',
      adminLabel: '管理员',
      needLogin: '您需要登录后才可发布话题',
      loginEnter: '马上登录',
      loginCancel: '取消',
      searchCancel: '取消',
      fetchMore: '更多',
      emptyPostNew: '暂无内容'
    },
    // 帖子详情页
    detail: {
      deletedAccount: '账号已注销',
      emptyPost: '帖子不存在',
      deletePostBtn: '删除帖子',
      editPostBtn: '编辑帖子',
      lastModifiled: '最后编辑于',
      adminLabel: '管理员',
      // 浏览图标
      viewIconText: '浏览',
      // 评论图标
      CommentIconText: '评论',
      // 评论数量
      CommentNum: '评论',
      writeCommentBtn: '写评论',
      deleteCommentBtn: '删除评论',
      doWriteComment: '发表评论',
      writeReplyBtn: '回复',
      deleteReplyBtn: '删除回复',
      // 回复的文本编辑器
      reply: '回复',
      hideReplyBox: '收起回复框',
      doWriteReply: '发布回复',
      deleteTitle: '删除',
      confirmDelete: '你确定要删除吗？',
      deleteReason: '删除原因',
      selectDeleteReason: '请选择删除原因',
      deleteReason1: '垃圾广告信息：广告、照片、推广、测试等内容',
      deleteReason2: '违规内容：色情、暴力、血腥、敏感信息等',
      deleteReason3: '不友善内容：人身攻击、挑衅辱骂、恶意行为等',
      deleteCancel: '取消',
      deleteEnter: '确定',
      loginTips: '提示',
      needLogin: '您需要登录后才可发布评论',
      loginEnter: '马上登录',
      loginCancel: '取消'
    },
    // 帖子编辑页
    edit: {
      postTitle: '话题标题',
      postTitlePlaceholder: '标题不能超过30个字',
      postTitleError: '未填写话题标题',
      postContent: '话题内容',
      postContentError: '未填写话题内容',
      saveBtn: '更新',
      cancelBtn: '取消',
      confirmCancelEdit: '确定放弃编辑吗？',
      confirmEnter: '确定',
      confirmCancel: '取消'
    },
    // 发布新帖子
    new: {
      postTitle: '话题标题',
      postTitlePlaceholder: '标题不能超过30个字',
      postTitleError: '未填写话题标题',
      postContent: '话题内容',
      postContentError: '未填写话题内容',
      saveBtn: '发布'
    },
    // 我的主页
    userHome: {
      deletedAccount: '账号已注销',
      post: '话题',
      tab1: '全部话题',
      tab2: '动态',
      emptyPost: '还没有话题发布，快去发表新话题吧',
      lastModifiled: '最后编辑于',
      deleteBtn: '删除',
      emptyDynamic: '还没有任何动态哦',
      hasReplied: '回复了',
      yourPost: '您的话题',
      youInPost: '您在话题',
      commentInPost: '中的回复',
      hasBeenDeleted: '已被管理员删除',
      deleteReason: '删除原因',
      confirmDelete: '确定要删除吗？',
      confirmEnter: '确定',
      confirmCancel: '取消'
    }
  },
  // 个人中心
  self: {
    // 首页
    index: {
      title: '个人中心',
      user: '用户信息',
      authAccount: '账号授权',
      notice: '通知'
    },
    // 用户信息
    user: {
      nickname: '昵称',
      account: '账号',
      password: '密码',
      email: '邮箱',
      tel: '联系方式',
      wechat: '微信',
      unbinded: '未绑定',
      seted: '已设置',
      unset: '未设置',
      set: '设置',
      edit: '编辑',
      change: '更换',
      delete: '解绑',
      wechatTips: '解绑第三方账号，需先绑定手机号，确保账号安全',
      // 验证码
      validCodePlaceholder: '请输入验证码',
      validCodeSend: '获取验证码',
      validCodeSendAgain: '重新发送',
      // 发送邮箱
      emailNoRecived: '没有收到？',
      emailSendAgain: '重新发送',
      // 修改昵称相关
      nicknameSetTitle: '昵称设置',
      nicknameEditFormNicknamePlaceholder: '输入昵称',
      nicknameFormNicknameRule: '2-24位中英文、数字，支持-_字符',
      nicknameEditBtn: '确定',
      nicknameEditCancel: '返回',
      // 修改密码相关
      // 修改密码时未进行身份验证
      pswSetTitle: '设置密码',
      pswEditTitle: '编辑密码',
      pswOldPasswordPlaceholder: '原密码',
      pswEditToAuthTitle: '身份验证',
      pswEditToAuthTips: '为保护账号安全，需先验证当前密码，验证成功后进行下一步操作',
      pswEditToAuthForgot: '忘记密码',
      pswNewPasswordPlaceholder: '新密码',
      pswConfirmPasswordPlaceholder: '确认密码',
      pswPasswordRule: '8-24位数字、字母或常用符号',
      pswEditNextBtn: '下一步',
      pswEditBtn: '确定',
      pswEditCancel: '返回',
      // 绑定、修改邮箱相关
      emailSetTitle: '绑定邮箱',
      emailEditTitle: '更换邮箱',
      emailDeleteTitle: '解绑邮箱',
      // 修改邮箱前验证
      emailEditToAuthTitle: '身份验证，更换邮箱',
      emailEditToAuthTips: '为保护账号安全，需先验证当前邮箱，验证成功后进行下一步操作',
      emailEditToAuthNextBtn: '下一步',
      // 填写新邮箱
      emailEditFormEmailPlaceholder: '输入邮箱',
      emailEditNewEmailTitle: '身份验证，完成更换',
      emailEditNewEmailTips: '验证码已发送至邮箱 {email}，请注意查收并在下方填写',
      emailEditBtn: '确定',
      // 解除绑定
      emailDeleteConfirmTitle: '确认解绑',
      emailDeleteConfirmTips: '解绑将无法继续使用该邮箱作为账号登录极飞稻草人',
      emailDeleteConfirmEnter: '确定',
      emailDeleteConfirmCancel: '返回',
      emailDeleteToAuthTitle: '身份验证，解绑邮箱',
      emailDeleteToAuthTips: '验证码已发送至邮箱{email}，请注意查收并在下方填写',
      emailDeleteBtn: '确定',
      // 绑定，修改手机相关
      telSetTitle: '绑定联系方式',
      telEditTitle: '更换联系方式',
      telDeleteTitle: '解绑联系方式',
      // 原手机验证
      telEditToAuthTitle: '身份验证，更换手机号',
      telEditToAuthTips: '为保护账号安全，需先验证当前手机号，验证成功后进行下一步操作',
      telEditNextBtn: '下一步',
      telEditFormTelPlaceholder: '请输入联系方式',
      telEditBtn: '确定',
      // 解除绑定手机
      telDeleteConfirmTitle: '确认解绑',
      telDeleteConfirmTips: '解绑将无法继续使用该手机号作为账号登录极飞稻草人',
      telDeleteConfirmEnter: '确定',
      telDeleteConfirmCancel: '返回',
      telDeleteToAuthTitle: '身份验证，解绑手机号',
      telDeleteToAuthTips: '验证码已发送至手机 {tel}，请注意查收并在下方填写',
      telDeleteBtn: '确定',
      // 绑定、修改微信相关
      // 修改微信时未进行原微信验证
      wechatSetTitle: '绑定微信号',
      wechatDeleteTitle: '解绑微信号',
      wechatEditTitle: '完成验证，绑定新微信号',
      wechatEditTips: '请使用需要绑定的微信账号扫码进行绑定',
      // 解除绑定微信
      wechatDeleteConfirmTitle: '确认解绑',
      wechatDeleteConfirmTips: '解绑将无法继续使用该微信账号登录极飞稻草人',
      wechatDeleteConfirmEnter: '确定',
      wechatDeleteConfirmCancel: '返回',
      wechatEditToDeleteTips: '请使用当前绑定的微信账号扫码验证以解除绑定',
      // 字段验证 规则错误
      nicknameFormatError: '昵称格式：2-24位中英文、数字，支持-_字符',
      pswFormatError: '密码输入格式有误，请重新输入',
      pswEmptyError: '密码不可为空',
      oldPswEmptyError: '旧密码不可为空',
      pswConfirmError: '两次密码输入不一致，请重新输入',
      emailEmptyError: '请输入邮箱',
      emailSameError: '与原邮箱一致，无需修改',
      emailFormatError: '邮箱格式错误，请重新输入',
      validCodeEmptyError: '请输入验证码',
      validCodeError: '验证码错误',
      telEmptyError: '请输入联系方式',
      telSameError: '与原联系方式一致，无需修改',
      telFormatError: '请输入正确的联系方式',
      validCodeImgEmptyError: '请输入右侧图形码',
      // 注销账号
      deleteAccount: '注销账号'
    },
    // 授权账号
    authAccount: {
      addAuthAccountBtn: '添加账号',
      authAccountEmpty: '暂无授权账号',
      nicknameAndAccount: '昵称（账号）',
      authority: '权限',
      authorityReadOnly: '只读',
      authorityReadWrite: '读写',
      operation: '操作',
      operationEdit: '管理',
      operationDelete: '删除',
      // 添加授权账号
      addSubAccountTitle: '添加账号',
      subAccountTypePerson: '个人',
      subAccountTypePlaform: '平台',
      subAccountInput: '添加账号',
      subAccountInputPlaceholder: '输入授权账号',
      subAccountInputEmptyError: '请输入授权账号',
      subAccountInputFormatError: '请填写正确格式的账号',
      subAccountSelectPlaceholder: '选择平台账号',
      subAccountSelectEmptyError: '请选择平台账号',
      subAccountExistError: '该账号已添加',
      subAccountBack: '返回',
      subAccountAddBtn: '添加',
      // 授权账号个数超出限制提示
      subAccountOverLimit: '授权账号最多可添加{max}个，已达上限',
      // 删除授权账号
      subAccountDeleteConfirmTitle: '删除',
      subAccountDeleteConfirm: '确定删除该授权账号吗？',
      subAccountDeleteConfirmEnter: '确认',
      subAccountDeleteConfirmCancel: '取消',
      // 添加设备弹出框
      addDevicesTitlePerson: '个人 >> ',
      addDevicesTitleStep1: '添加设备 >> ',
      addDevicesTitleStep2: '权限管理',
      devicesEmpty: '暂无可授权的拥有设备',
      deviceName: '设备名称',
      addDevicesSkip: '跳过',
      addDevicesBack: '返回',
      addDevicesNext: '下一步',
      addDevicesPrevious: '上一步',
      addDevicesEnter: '确定',
      addDevicesSelectionsEmpty: '未选择任何设备',
      // 权限管理弹出框
      authEditTitle: '账号权限管理',
      authDevicesEmpty: '未添加授权设备',
      authDevicesToAddDevices: '添加设备',
      authDevicesCheckAll: '全选',
      authDevicesDelete: '删除',
      authEditCancel: '取消',
      authEditSaveBtn: '保存',
      authEditNoUpdate: '无可更新的内容',
      // 正在操作提示框
      progressTitleDefault: '正在操作',
      progressContentDefault: '',
      progressTitleComplete: '操作提示',
      progressContentSuccess: '成功',
      progressContentFail: '失败'
    },
    // 通知
    notice: {
      setAllRead: '全部标为已读',
      setRead: '标为已读',
      noticeEmpty: '当前没有通知',
      newLabel: '新'
    }
  },
  // 平台中心
  platform: {
    index: { // 首页菜单
      title: '平台中心',
      platformAccess: '平台接入',
      platformInfo: '平台信息',
      softwarePlatform: '软件平台',
      softwareSetting: '基本配置',
      softwareTools: '实用工具',
      softwareAPI: '接口文档',
      // 这里一大部分的api相关
      introduction: '概述',
      docLi0: '开放平台',
      docLi1: '鉴权',
      docLi2: '接口汇总',
      api: 'API',
      docLi3: '1.1 用户登录 ',
      docLi4: '1.2 用户登出',
      docLi5: '1.3 查询第三方授权账号列表',
      docLi6: '2.1 修改设备信息',
      docLi7: '2.2 查询设备',
      docLi8: '2.3 查询用户设备列表',
      docLi9: '2.4 添加设备(关注)',
      docLi10: '2.5 删除设备(取消关注)',
      docLi11: '3.1 查询设备数据点（按时间筛选）',
      docLi12: '3.2 获取设备最近一条数据点',
      docLi13: '4.1 获取设备直播地址',
      docLi14: '5.1 查询设备月积温数据',
      docLi15: '5.2 查询设备月降雨量',
      docLi16: '5.3 查询设备统计数据',
      docLi17: '5.4 查询设备流量数据(已废弃)',
      docLi18: '5.5 查询设备流量数据',
      docLi19: '6.1 消息推送',
      docLi20: '7.1 兑换券购买商品',
      docLi21: '7.2 查询兑换券',
      messages: '消息体附录',
      docLi22: '设备上下状态消息格式',
      docLi23: '数据点消息推送格式',
      datapoints: '数据点附录',
      docLi24: 'FM1',
      docLi25: 'FM2',
      docLi26: 'ITL Pro(RTK)',
      docLi27: 'ITL(GPS)',
      docLi28: 'IFC16',
      docLi29: 'IWS7',
      docLi30: 'ISM50',
      docLi31: 'IWS3',
      docLi32: 'IFC16S',
      docLi33: 'IFC13S',
      docLi34: 'ISM50S',
      docLi35: 'IWS7S',
      docLi36: 'IWS3S',
      config: '设备配置附录',
      softwareSampleCode: '示例代码',
      sampleCodeSignature: '签名',
      sampleCodePassword: '密码',
      hardwarePlatform: '硬件平台',
      hardwareModule: '模块列表',
      hardwareAPI: '接口文档',
      sensorAndController: '传感器与控制',
      http: 'HTTP',
      sdk: 'SDK'
    },
    // 平台申请开通 与 平台信息修改使用同一份文案
    platformAccess: {
      hardwarePlatform: '硬件平台',
      hardwarePlatformDesc: '提供RS485硬件接口，Modbus RTU通讯协议方式接入系统。',
      softwarePlatform: '软件平台',
      softwarePlatformDesc: '提供HTTPS协议接口，用于管理和获取设备数据等。',
      platformOpened: '已开通',
      platformNotOpen: '未开通',
      applicationSteps1: '填写资料',
      applicationSteps2: '等待审核',
      applicationSteps3: '完成验证',
      applicationExistError: '存在待审核信息，暂不支持申请',
      // 资料不完整
      userinfoIncompleteHardwarePlatform: '硬件平台',
      userinfoIncompleteSoftwarePlatform: '软件平台',
      userinfoIncompletePlatformInfo: '平台信息',
      userinfoIncomplete: '当前用户信息不完善，',
      userinfoIncompleteToAdd: '前往补充',
      userinfoIncompleteApplyTips1: '申请',
      userinfoIncompleteApplyTips2: '资质需用户补充完整的手机号、邮箱，可先完善信息再申请',
      userinfoIncompleteModifyTips1: '修改',
      userinfoIncompleteModifyTips2: '资质需用户补充完整的手机号、邮箱，可先完善信息再修改',
      // 修改资料
      userinfoModifyBtn: '修改',
      // 步骤1，填写资料
      company: '公司名称',
      companyPlaceholder: '填写公司名称',
      companyEmptyError: '填写公司名称',
      companyFormatError: '填写的公司名称过长，限制80字符',
      region: '所在地区',
      regionPlaceholder: '请选择 省/市',
      regionEmptyError: '请选择所在地区',
      contacts: '联系人',
      contactsPlaceholder: '填写联系人',
      contactsEmptyError: '请填写联系人',
      contactsFormatError: '请填写正确的字符，不支持数字与符号，限制80字符',
      applicationReason: '申请说明',
      applicationReasonPlaceholder: '请填写申请说明',
      applicationReasonEmptyError: '请填写申请说明',
      applicationReasonFormatError: '填写的内容过长，限制100字符',
      backBtn: '返回',
      submitToAuditBtn: '提交审核',
      applicationSubmitSuccess: '提交资料成功',
      applicationSubmitSuccessTips: '我们将在第一时间审核，请等待结果',
      // 审核通过
      applicationAuditSuccess: '验证成功',
      applicationAuditSuccessToUseBtn: '开始使用',
      applicationAuditFail: '验证失败',
      applicationAuditFailReason: '失败原因：',
      applicationAuditFailConfirmBtn: '确定',
      applicationAuditFailReapply: '重新申请',
      applicationAuditFailReModify: '重新修改'
    },
    // 基本设置
    softwareSetting: {
      clientId: 'client_id',
      clientIdDesc: '添加到API请求URL参数',
      secret: 'secret',
      secretDesc: '用于生成签名后将签名添加到API请求URL参数',
      url: '消息推送URL',
      urlDesc: '用于接收设备发送消息，当设备发送消息时将消息推送到设置的URL服务器',
      urlFormatError: '请填写正确格式的URL地址',
      ipWhiteList: 'IP白名单',
      EditBtn: '设置',
      ipWhiteListDesc1: '1、设置白名单后会限制API访问服务器IP，如未设置白名单部分API接口将无法访问',
      ipWhiteListDesc2: '2、IP白名单成功设置1分钟后生效',
      saveBtn: '保存',
      subject: '主题接收',
      subjectDesc: '',
      subjectAll: '接收所有',
      subjectPart: '仅接收指定主题',
      subjectError: '主题接收填写错误，请检查',
      ipWhiteListEditTitle: '添加白名单',
      ipWhiteListEditTips: '注：支持添加{max}个白名单',
      ipPlaceholder: '输入IP地址',
      ipEmptyError: '请填写IP地址',
      ipFormatError: '请填写正确格式的IP地址',
      ipOverError: '支持添加{max}个白名单，已添加{total}个',
      ipExistError: '该IP地址已添加',
      ipAddBtn: '添加',
      ipWhiteListEmpty: '暂无白名单',
      ip: '白名单',
      operation: '操作',
      deleteBtn: '删除',
      backBtn: '返回',
      commitBtn: '确定'
    },
    // 示例代码
    sampleCode: {
      copyCode: '复制代码',
      copySuccess: '复制成功',
      copyFail: '复制失败'
    },
    // 实用工具
    tools: {
      signature: '签名',
      password: '密码',
      passwordTips: '* password 为随机字符串，仅用于验证算法',
      getSignatureBtn: '生成签名',
      getEncryptedDataBtn: '生成加密密码'
    },
    // 模块列表
    hardwareModule: {
      status: '状态',
      all: '全部',
      passed: '已通过',
      auditting: '审核中',
      noPassed: '不通过',
      addModuleBtn: '添加',
      // 模块列表内容
      moduleListEmpty: '暂无数据，请添加',
      name: '名称',
      protocol: '协议',
      model: '型号',
      content: '内容',
      viewContentBtn: '详情',
      operation: '操作',
      editBtn: '编辑',
      releaseBtn: '发布',
      recallBtn: '撤回',
      deleteBtn: '删除',
      saveBtn: '保存', // 排序保存按钮
      unsupportedModule: '暂无不支持显示的模块类型',
      // 关闭模块详情提示
      closeModuleDetailComfirm: '当前操作未保存，确定关闭？',
      closeModuleDetailTitle: '关闭',
      closeModuleDetailComfirmEnter: '关闭',
      closeModuleDetailComfirmCancel: '取消',
      // 添加模块
      moduleStep1: '模块信息',
      moduleStep2: '模块配置',
      moduleStep3: '提交审核',
      // 模块配置字段
      s_addr: '从机地址',
      s_addrPlacrholder: '输入从机地址，如100。支持1～250，请勿使用广播地址',
      s_addrEmptyError: '请填写从机地址',
      s_addrFormatError: '仅限填写1 ~ 250 的整数值，请勿使用广播地址',
      conf_addr: '配置地址',
      conf_addrPlaceholder: '输入配置地址，如100',
      conf_addrEmptyError: '请填写配置地址',
      conf_addrFormatError: '仅限填写0 ~ 65535 的整数值',
      baud_rate: '波特率',
      baud_ratePlaceholder: '请选择波特率',
      baud_rateEmptyError: '请选择波特率',
      parity: '校验位',
      parityPlaceholder: '请选择校验位',
      moduleName: '模块名称',
      moduleNamePlaceholder: '输入模块名称，如二合一温湿度',
      moduleNameEmptyError: '请填写模块名称',
      moduleNameFormatError: '模块名称长度不可超过15个字符',
      moduelModel: '模块型号',
      moduelModelPlaceholder: '输入模块型号，如WS1',
      moduleModelEmptyError: '请填写模块名称',
      moduelModelFormatError: '模块名称仅限填写英文字母、数字及下划线_',
      moduelModelFormatErrorLength: '模块型号不可超过15个字符',
      moduelModelExistError: '该模块型号已存在，请修改模块型号',
      backBtn: '返回',
      nextBtn: '下一步',
      // 返回上层确认
      backToModuleTitle: '返回',
      backToModuleComfirm: '返回上一步，当前修改数据将不会被保存，您确定返回吗？',
      moduleDataError: '配置中存在未填写或不符合要求的数据，请检查',
      // 具体模块配置
      sensorName: '名称',
      sensorNamePlaceholder: '输入名称，如传感器1',
      sensorNameEmptyError: '请填写名称',
      sensorNameFormatError: '名称不可超过15个字符',
      sensorType: '类型',
      sensorTypePlaceholder: '请选择模块类型',
      sensorTypeEmptyError: '请选择模块类型',
      sensorTypeLimitError: '此类型模块只允许添加{max}个，已超过限制个数',
      r_type: '寄存器类型',
      r_typePlaceholder: '请选择寄存器类型',
      r_typeEmptyError: '请选择寄存器类型',
      d_addr: '数据地址',
      d_addrPlaceholder: '填写数据地址，如100',
      d_addrEmptyError: '请填写数据地址',
      d_addrFormatError: '仅限填写0 ~ 255 的整数值',
      format: '数据格式',
      formatPlaceholder: '请选择数据格式',
      formatEmptyError: '请选择数据格式',
      formula: '数据公式',
      formulaPlaceholder: '请选择公式',
      formulaEmptyError: '请选择公式',
      validRange: '有效区间',
      validRangeEmptyError: '请填写有效区间',
      validRangeFormatError: '请填写整数值',
      validRangeOverRangeError: '仅限填写',
      minBiggerThanMaxError: '输入的最小值大于最大值',
      minPlaceholder: '最小值',
      maxSmallerThanMinError: '输入的最大值小于最小值',
      maxPlaceholder: '最大值',
      unit: '单位',
      unitEmptyPlaceholder: '无',
      unitPlaceholder: '请选择单位',
      map: '映射表',
      mapEmpty: '无',
      code: '状态码',
      codePlaceholder: '状态码{index}',
      validCodeRangeError: '请先填写模块的有效区间',
      validCodeFormatError: '状态码仅限填写有效区间内的合法整数值',
      validCodeRepeatError: '映射表中存在重复状态码，请检查',
      desc: '描述',
      descPlaceholder: '描述',
      validDescFormatError: '描述仅限填写30字符',
      validDescEmptyError: '映射表中存在无对应状态码的描述，请检查',
      preBtn: '上一步',
      moduleApplyBtn: '确定添加',
      moduleEditBtn: '确定编辑',
      // 模块添加成功
      applicationSubmitSuccess: '提交模块成功',
      applicationSubmitSuccessTips: '我们将在第一时间审核，请等待结果',
      viewModuleListBtn: '查看列表',
      addModuleMoreBtn: '继续添加',
      // 编辑/删除/发布/撤回模块
      editModuleTitle: '编辑模块',
      editModuleConfirm: '确认编辑该模块，将撤回该模块在用户盒子添加列表中的选项。',
      deleteModuleTitle: '删除模块',
      deleteModuleConfirm: '确定删除该模块吗？',
      deleteReleasedModuleConfirm: '确认删除该模块，用户将无法在盒子添加列表选项中查看模块信息。',
      releaseModuleTitle: '发布',
      releaseModuleConfirm: '发布完成后，模块信息将通过硬件平台对外开放。',
      recallModuleTitle: '撤回',
      recallModuleConfirm: '将撤回硬件平台模块在盒子添加列表选项，用户将无法查看模块信息。',
      confirmEnter: '确定',
      confirmCancel: '取消'
    }
  },
  // 接口请求 200 默认成功 0 默认失败
  request: {
    401: '未登录',
    411: '登录状态过期',
    // 账号登陆
    login: {
      200: '登录成功',
      0: '登录失败，账号或密码错误',
      40002: '登录失败，账号或密码错误',
      40003: '登录失败：密码错误次数过多，请稍后重试'
    },
    // 手机+验证码登录
    telLogin: {
      200: '登录成功',
      0: '登录失败，手机号或验证码错误',
      40002: '登录失败'
    },
    // 用户名校验
    checkAccount: {
      200: '',
      0: '该用户名已被使用，请输入其他用户名',
      40005: '该用户名已被使用，请输入其他用户名'
    },
    // 邮箱校验
    checkEmail: {
      200: '',
      0: '该邮箱已被使用，请重新输入',
      40305: '该邮箱已被使用，请重新输入'
    },
    // 注册账号前的邮箱验证
    signupPre: {
      200: '邮件发送成功',
      0: '邮件发送失败',
      40004: '邮件发送失败，用户名格式错误',
      40201: '邮件发送失败，邮箱格式错误',
      40305: '邮件发送失败，该邮箱已被使用',
      40005: '邮件发送失败，用户名已被使用',
      40006: '邮件发送失败，密码格式错误'
    },
    // 邮箱账号注册后，激活账号
    signup: {
      200: '账号注册成功，即将跳转至登录',
      0: '账号注册失败',
      40000: '账号注册失败',
      40004: '账号注册失败，用户名格式错误',
      40005: '账号注册失败，用户名已被使用',
      40006: '账号注册失败，密码格式错误',
      40021: '账号注册失败，验证码错误或已失效',
      40201: '账号注册失败，邮箱格式错误',
      40305: '账号注册失败，该邮箱已被使用',
      40307: '账号注册失败，验证码错误或已失效'
    },
    // 注销账号
    deleteAccount: {
      200: '账号注销成功',
      0: '注销失败，请重试'
    },
    // 忘记密码 重置前的发送验证码
    forgotPasswordSendValidcode: {
      200: '验证码发送成功',
      0: '验证码发送失败',
      40001: '验证码发送失败，用户不存在',
      40301: '验证码发送失败，用户未设置有效的手机或邮箱',
      40302: '验证码发送失败，用户未设置有效的手机或邮箱',
      40303: '验证码发送失败，用户未设置有效的手机或邮箱'
    },
    // 对校验码的验证
    forgotPasswordVerify: {
      200: '验证成功',
      0: '验证失败',
      40021: '验证失败，验证码错误或已失效，请重新获取',
      40022: '验证失败，验证码错误或已失效，请重新获取'
    },
    // 忘记密码 重置密码
    resetPassword: {
      200: '密码重置成功',
      0: '密码重置失败',
      40021: '密码重置失败，验证码错误或已失效，请重新获取。',
      40022: '密码重置失败，验证码错误或已失效，请重新获取。',
      40401: '密码重置失败，密码无变化'
    },
    // 获取帖子列表 / 动态列表
    getPost: {
      200: '获取成功',
      0: '获取失败'
    },
    // 删除帖子 / 删除动态 / 删除评论 / 删除回复
    deletePost: {
      200: '删除成功',
      0: '删除失败'
    },
    // 搜索帖子列表
    searchPost: {
      200: '搜索成功',
      0: '搜索失败'
    },
    // 发布帖子
    newPost: {
      200: '话题发布成功',
      0: '话题发布失败，请检查话题内容中是否含有表情字符等不支持字符。'
    },
    // 编辑帖子
    editPost: {
      200: '话题编辑成功',
      0: '话题编辑失败，请检查话题内容中是否含有表情字符等不支持字符。'
    },
    // 获取帖子详情
    getPostDetail: {
      200: '话题加载成功',
      0: '无法获取话题详情，该话题或已删除。'
    },
    // 发布对帖子的评论
    newComment: {
      200: '评论发布成功',
      0: '评论发布失败，请检查评论内容中是否含有表情字符等不支持字符。'
    },
    // 发布对评论的回复
    newReply: {
      200: '回复成功',
      0: '回复失败，请检查回复内容中是否含有表情字符等不支持字符。'
    },
    // 修改昵称
    editNickname: {
      200: '昵称设置成功',
      0: '昵称设置失败',
      40311: '昵称设置失败，格式错误'
    },
    // 设置/修改密码， 使用旧密码以验证用户
    editPasswordVerify: {
      200: '验证成功',
      0: '验证失败，密码错误',
      40002: '验证失败，密码错误',
      40003: '验证失败，密码错误次数过多，请稍后重试'
    },
    // 设置/修改密码
    editPassword: {
      200: '密码设置成功',
      0: '密码设置失败',
      40021: '密码设置失败，验证码错误或已失效',
      40401: '密码设置失败，密码无变化'
    },
    // 发送验证邮件到邮箱
    sendEmail: {
      200: '邮件发送成功',
      0: '邮件发送失败',
      40201: '邮件发送失败，邮箱格式错误',
      40305: '邮件发送失败，该邮箱已被使用'
    },
    // 发送手机验证码
    sendVcode: {
      200: '手机验证码发送成功',
      0: '手机验证码发送失败'
    },
    // 验证原邮箱
    verifyEmail: {
      200: '邮箱验证成功',
      0: '邮箱验证失败',
      40021: '邮箱验证失败，验证码错误',
      40201: '邮箱格式错误',
      40307: '邮箱验证超时',
      40308: '邮箱与账号不匹配'
    },
    // 验证原手机
    verifyTel: {
      200: '手机验证成功',
      0: '验证失败',
      40021: '验证失败，验证码错误',
      40022: '验证失败，验证码已过期'
    },
    // 轮询 验证原微信
    verifyWechat: {
      200: '微信验证成功',
      0: '验证失败，请使用当前绑定的微信扫码进行验证'
    },
    // 修改用户绑定的邮箱（包括新增 及 修改）
    editEmail: {
      200: '邮箱设置成功',
      0: '邮箱绑定失败',
      40021: '邮箱绑定失败，验证码错误',
      40201: '邮箱绑定失败，邮箱格式错误',
      40305: '邮箱绑定失败，该邮箱已被使用',
      40307: '邮箱绑定失败，链接已失效，请重新申请',
      40308: '邮箱绑定失败，当前账号与申请邮箱修改的账号不一致',
      40309: '邮箱绑定失败，当前账号已绑定该邮箱'
    },
    // 修改联系方式 （包括新增 及 修改）
    editTel: {
      200: '联系方式设置成功',
      0: '联系方式绑定失败',
      40021: '联系方式绑定失败，验证码错误',
      40022: '联系方式绑定失败，验证码已失效',
      40023: '联系方式绑定失败，该手机号已被使用',
      40025: '联系方式绑定失败，该手机号与原手机号相同'
    },
    // 修改微信 （包括新增 及 修改）
    editWechat: {
      200: '微信设置成功',
      0: '微信绑定失败',
      40310: '微信绑定失败，该微信已绑定此账号',
      40306: '微信绑定失败，该微信已被其他账号绑定'
    },
    // 解除绑联系方式, 邮箱,微信
    deleteInfo: {
      200: '解除绑定成功',
      0: '解除绑定失败',
      40021: '解绑失败，验证码错误',
      40022: '解绑失败，验证码失效'
    },
    // 验证输入的授权账号
    checkSubAccount: {
      200: '',
      1: '填写的账号已添加',
      0: '填写的账号无法添加',
      40001: '填写的账号不存在',
      40004: '填写的账号格式错误',
      40016: '填写的账号没有API权限',
      40017: '填写的账号非普通用户类型',
      40304: '填写的账号非邮箱注册账号',
      40601: '填写的账号不可与当前账号相同',
      40602: '已添加的授权账号数量超出限制'
    },
    // 添加授权账号
    addSubAccount: {
      200: '授权账号添加成功',
      0: '授权账号添加失败',
      40001: '授权账号添加失，该账号不存在',
      40004: '授权账号添加失，该账号格式错误',
      40016: '授权账号添加失，该账号没有API权限',
      40017: '授权账号添加失，该账号非普通用户类型',
      40304: '授权账号添加失，该账号非邮箱注册账号',
      40601: '授权账号添加失，该账号不可与当前账号相同',
      40602: '授权账号添加失，已添加的授权账号数量超出限制'
    },
    // 删除授权账号
    deleteSubAccount: {
      200: '授权账号删除成功',
      0: '授权账号删除失败'
    },
    // 获取已授权设备列表
    getAuthedDevices: {
      200: '获取已授权设备列表成功',
      0: '获取已授权列表失败'
    },
    // 获取可授权设备列表
    getUnAuthedDevices: {
      200: '获取可授权设备列表成功',
      0: '获取可授权列表失败'
    },
    // 添加授权设备
    addAuthedDevices: {
      200: '设备授权成功',
      0: '设备授权失败'
    },
    // 更新授权设备权限
    updateAuth: {
      200: '授权设备更新成功',
      0: '授权设备更新失败'
    },
    // 提交申请 审核
    newApply: {
      200: '审核提交成功',
      0: '审核提交失败',
      41000: '提交审核失败: 已存在待审核信息，请勿重复申请',
      41001: '提交审核失败: 无效公司名称',
      41002: '提交审核失败: 未填写有效公司地区',
      41003: '提交审核失败: 无效联系人',
      41010: '提交审核失败: 申请说明内容过长',
      40302: '提交审核失败: 未填写有效联系方式'
    },
    comfrimApply: {
      200: '审核确认成功',
      0: '审核确认失败'
    },
    // 更新 开发者设置
    editDevConfig: {
      200: '设置成功',
      0: '设置失败'
    },
    // 校验模块型号
    checkModel: {
      200: '',
      0: '该模块型号已存在，请修改模块型号'
    },
    // 获取模块列表
    getModuleList: {
      200: '模块列表加载成功',
      0: '模块列表加载失败'
    },
    // 发布模块
    releaseModule: {
      200: '模块已发布',
      0: '模块发布失败',
      42002: '模块发布失败，当前用户未开通硬件API权限',
      42003: '模块发布失败，状态无变化',
      42004: '模块发布失败，该模块未通过审核'
    },
    // 撤回模块
    recallModule: {
      200: '模块已撤回',
      0: '模块撤回失败',
      42002: '模块撤回失败，当前用户未开通硬件API权限',
      42003: '模块撤回失败，状态无变化',
      42004: '模块撤回失败，该模块未发布'
    },
    // 添加模块 / 编辑模块
    addModule: {
      200: '模块提交成功',
      0: '模块提交失败',
      42000: '模块提交失败，该模块型号已被申请，请修改模块型号'
    },
    // 删除模块
    deleteModule: {
      200: '模块删除成功',
      0: '模块删除失败'
    },
    // 模块排序保存
    rankModule: {
      200: '保存成功',
      0: '保存失败'
    }
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js